<template>
  <div class="main pa-3">
    <v-toolbar elevation="0" class="custom-toolbar mt-4">
      <v-toolbar-title>
        <h1>{{ $vuetify.lang.t('$vuetify.courseManagement.myCourse') }}</h1>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        v-on="on"
        elevation="0"
        class="
          pl-5
          pr-5
          mr-5
          xs-full-width
          font-weight-light
          body-2
          button-secondary
        "
        @click="openRecycleBin()"
      >
        <v-icon left>mdi-delete-outline</v-icon>
        {{ $vuetify.lang.t('$vuetify.courseManagement.recycleBin') }}
      </v-btn>
      <v-btn
        elevation="0"
        @click="gotoDetail"
        class="pl-5 pr-5 xs-full-width font-weight-light body-2 button-primary"
      >
        <v-icon left>mdi-plus</v-icon>
        {{ $vuetify.lang.t('$vuetify.courseManagement.newCourse') }}
      </v-btn>
    </v-toolbar>
    <!-- <v-row class="mx-1">
      <v-col class="display-1 font-weight-bold">
        {{ $vuetify.lang.t("$vuetify.courseManagement.myCourse") }}
      </v-col>
      <v-col class="ml-5 xs-full-width text-right">  
      </v-col>
    </v-row> -->
    <v-row>
      <v-col cols="12" class="px-7">
        <v-sheet color="white" class="pa-2">
          <v-row class="px-4">
            <v-col cols="12" sm="6" md="3">
              <span class="caption">
                {{ $vuetify.lang.t('$vuetify.courseManagement.search') }}
              </span>
              <v-text-field
                outlined
                v-model="searchdata"
                @change="searchInfo(searchdata)"
                :placeholder="
                  $vuetify.lang.t('$vuetify.courseManagement.search')
                "
                clearable
                hide-details
                background-color="#fff"
                height="40"
              ></v-text-field>
            </v-col>

            <!--<div class="mr-md-5 mt-10 md-fixed-max-width xs-full-max-width xs-full-width">
            <p class="mb-2 caption font-weight-medium text-caption">SEARCH BY</p>
            <v-autocomplete
              v-model="searchby"
              :items="searchType"
              v-on:change="onSort"
              outlined
              height="40"
              background-color="#fff"
              :placeholder="$vuetify.lang.t('$vuetify.courseManagement.searchBy')"
            ></v-autocomplete>
          </div>-->
            <v-col cols="12" sm="6" md="3">
              <span class="caption">
                {{ $vuetify.lang.t('$vuetify.courseManagement.sort') }}
              </span>
              <v-autocomplete
                v-model="sortData"
                :items="sortType"
                v-on:change="onSort"
                outlined
                hide-details
                background-color="#fff"
                height="40"
                :placeholder="$vuetify.lang.t('$vuetify.courseManagement.sort')"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <span class="caption">
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.filterBar.categories'
                  )
                }}
              </span>
              <v-combobox
                v-model="selectedCategory"
                :items="category"
                item-text="title"
                :placeholder="
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.filterBar.plsChooseCategories'
                  )
                "
                hide-details
                outlined
                height="40"
                background-color="white"
                @change="applyFilter"
              ></v-combobox>
            </v-col>
            <v-col cols="12" sm="6" md="2" class="mt-auto">
              <p class="caption mb-0">
                {{
                  $vuetify.lang.t('$vuetify.courseManagement.filterBar.status')
                }}
              </p>
              <v-btn-toggle
                class="mb-0"
                color="primary accent-3"
                background-color="white"
                mandatory
                v-model="status_toggle"
              >
                <v-btn
                  class="text-capitalize body-2"
                  @change="changeActive(null)"
                  height="40px"
                >
                  {{
                    $vuetify.lang.t('$vuetify.courseManagement.filterBar.all')
                  }}
                </v-btn>
                <v-btn
                  class="text-capitalize body-2"
                  @change="changeActive(true)"
                  height="40px"
                >
                  {{
                    $vuetify.lang.t('$vuetify.courseManagement.filterBar.on')
                  }}
                </v-btn>
                <v-btn
                  class="text-capitalize body-2"
                  @change="changeActive(false)"
                  height="40px"
                >
                  {{
                    $vuetify.lang.t('$vuetify.courseManagement.filterBar.off')
                  }}
                </v-btn>
              </v-btn-toggle>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="2"
              class="mt-auto"
              style="display: flex; justify-content: flex-end"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="pl-5 pr-5 btn-reload body-2"
                    height="40"
                    @click="initialize"
                  >
                    <v-icon>mdi-cached</v-icon>
                    <!-- {{ $vuetify.lang.t("$vuetify.courseManagement.filterBar.refresh") }} -->
                  </v-btn>
                </template>
                <span>{{
                  $vuetify.lang.t('$vuetify.learnerManagement.filterBar.reload')
                }}</span>
              </v-tooltip>
              <!-- <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="ml-3 pl-5 pr-5 btn-reload body-2"
                    height="40"
                    @click="openRecycleBin()"
                  >
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{
                  $vuetify.lang.t('$vuetify.courseManagement.filterBar.bin')
                }}</span>
              </v-tooltip> -->
            </v-col>
          </v-row>
          <v-row class="px-4 pb-2">
            <v-col cols="6">
              <span class="caption">
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.filterBar.groupFilter'
                  )
                }}
              </span>
              <v-combobox
                id="group"
                hide-details
                v-model="userGroupSearch"
                :items="arrayGroup"
                item-text="title"
                item-value="_id"
                :placeholder="
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.filterBar.selectGroup'
                  )
                "
                outlined
                dense
                multiple
                @change="applyFilterUserGroup"
                required
                small-chips
                background-color="white"
              >
                <template v-slot:selection="{ attrs, item, parent, selected }">
                  <v-chip
                    class="ma-1"
                    v-if="item === Object(item)"
                    v-bind="attrs"
                    :input-value="selected"
                    label
                    small
                  >
                    <span class="pr-2">
                      {{ item.title }}
                    </span>
                    <v-icon small @click="parent.selectItem(item)">
                      mdi-close-circle
                    </v-icon>
                  </v-chip>
                </template></v-combobox
              >
            </v-col>
            <v-col cols="6">
              <span class="caption">
                {{
                  $vuetify.lang.t('$vuetify.courseManagement.filterBar.skills')
                }}
              </span>
              <v-combobox
                id="group"
                :menu-props="{ value: autoselectMenu }"
                @keypress="skillOtherKey"
                v-model="selectedSkills"
                :items="skill"
                item-text="title"
                height="40"
                multiple
                outlined
                solo
                flat
                hide-details
                persistent-hint
                :placeholder="
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.filterBar.plsChooseSkill'
                  )
                "
                @change="applyFilter"
                :search-input.sync="searchSkill"
              >
                <template v-slot:selection="{ attrs, item, parent, selected }">
                  <v-chip
                    class="ma-1"
                    v-if="item === Object(item)"
                    v-bind="attrs"
                    :input-value="selected"
                    label
                    small
                  >
                    <span class="pr-2">
                      {{ item.title }}
                    </span>
                    <v-icon small @click="parent.selectItem(item)">
                      mdi-close-circle
                    </v-icon>
                  </v-chip>
                </template>
                <!-- <template v-slot:selection="data">
                  <div
                    v-if="
                      selectedSkill[selectedSkill.length - 1].title ==
                      data.item.title
                    "
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    small
                  >
                    <span class="font-weight-light subtitle-2"
                      >{{ selectedSkill.length }} {{ selectedSkills }}</span
                    >
                  </div>
                </template> -->
              </v-combobox>
            </v-col>

            <!-- <v-col cols="12" sm="6" md="3"> 
            <span class="caption">
              {{ $vuetify.lang.t("$vuetify.courseManagement.filterBar.tags") }}
            </span>
            <v-combobox
              id="group"
              v-model="selectedTag"
              :items="tag"
              item-text="title"
              height="40"
              multiple
              outlined
              solo
              flat
              hide-details
              persistent-hint
              :placeholder="
                $vuetify.lang.t('$vuetify.courseManagement.filterBar.plsChooseTag')
              "
              @change="applyFilter"
            >
              <template v-slot:selection="data">
                <div
                  v-if="selectedTag[selectedTag.length - 1].title == data.item.title"
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  small
                >
                  <span class="font-weight-light subtitle-2"
                    >{{ selectedTag.length }} {{ selectedTags }}</span
                  >
                </div>
              </template>
            </v-combobox>
          </v-col> -->
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>
    <div class="body-table px-4">
      <v-card-actions v-if="selectCourses.length !== 0" class="bg-sheet">
        <p v-show="selectCourses.length !== 0" class="pl-3 mb-0">Selected</p>
        <v-row
          align="center"
          justify="end"
          style="margin-right: 10px !important"
        >
          <v-btn
            v-show="selectCourses.length !== 0"
            elevation="0"
            class="mb-0 body-2 text-capitalize"
            color="white"
            @click="cancelSelect()"
          >
            <p class="mb-0">
              {{
                $vuetify.lang.t('$vuetify.courseManagement.lectureStep.cancel')
              }}
            </p>
          </v-btn>
          <v-divider inset vertical class="mb-2 mx-1"></v-divider>
          <v-btn
            v-show="selectCourses.length !== 0"
            elevation="0"
            class="mb-0 body-2 text-capitalize"
            dark
            color="error"
            @click="confirmMultiDelete(null)"
          >
            <p class="mb-0">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.deleteSelected'
                )
              }}
            </p>
          </v-btn>
        </v-row>
      </v-card-actions>
      <v-data-table
        :loading="loading"
        :headers="headers"
        hide-default-footer
        :items="courses"
        show-select
        v-model="selectCourses"
        class="page-card font-weight-light"
        elevation="3"
        @toggle-select-all="selectAllToggle"
      >
        <!-- <template v-slot:item.data-table-select="{ item, isSelected, select }">
          <v-simple-checkbox
            :value="isSelected"
            :readonly="item.active"
            :disabled="item.active == true"
            @input="select($event)"
          ></v-simple-checkbox>
        </template> -->
        <template v-slot:item.image="{ item }">
          <a @click="editItem(item)">
            <v-img
              :src="item.image"
              class="my-2 rounded-card"
              width="120"
              aspect-ratio="1.7"
            >
              <template v-slot:placeholder>
                <v-row class="ma-0" align="center" justify="center">
                  <v-icon
                    v-if="!item.image"
                    class="mx-auto"
                    elevation="3"
                    size="70"
                    >mdi-image-outline</v-icon
                  >
                </v-row>
              </template>
            </v-img>
          </a>
        </template>
        <template v-slot:item.title="{ item }">
          <a @click="editItem(item)">
            <p class="ma-2 md-fixed-width body-2 font-weight-light text-left">
              {{ item.title }}
              <!-- <v-badge
                :offset-x="-1"
                :color="item.learnerRequest ? 'red' : 'transparent'"
              >
                <span slot="badge">{{ item.learnerRequest }}</span>
                <p class="mb-0">
                  {{ item.title }}
                </p>
              </v-badge> -->
            </p>
          </a>
        </template>
        <template v-slot:item.teacher="{ item }">
          <div v-for="teacher in item.teacher" :key="teacher._id._id">
            <p class="ma-2 xs-fixed-width body-2 font-weight-light">
              {{ teacher._id.displayName }}
            </p>
          </div>
        </template>
        <template v-slot:item.category="{ item }">
          <div v-for="category in item.category" :key="category._id">
            <p class="mb-0 body-2 font-weight-light">{{ category.title }}</p>
            <!--<v-chip class="ma-2 xs-fixed-width">}</v-chip>-->
          </div>
        </template>
        <template v-slot:item.owner_by_student="{ item }">
          <p class="ma-2 xs-fixed-width body-2 font-weight-light">
            {{ item.owner_by_student._id.displayName }}
          </p>
        </template>
        <!-- <template v-slot:item.price="{ item }">
          <div class="border-bottom" v-for="price in item.price" :key="price._id">
            <p
              class=" mb-0 full-width body-2 font-weight-light"
            >{{price.pricing==0 ? $vuetify.lang.t('$vuetify.courseManagement.courseList.free') : `${Number(price.pricing).toLocaleString()} ${$vuetify.lang.t('$vuetify.courseManagement.courseList.baht')}`}}</p>
            
          </div>
        </template>-->

        <template v-slot:item.active="{ item }">
          <!--<v-chip
            @click="$store.state.permission.activeCourse == true ? openModalStatus(item) : noPermission()"
            outlined
            :color="item.active==0 ?'red':'green'"
          >
            <v-avatar left>
              <v-icon x-small>mdi-checkbox-blank-circle</v-icon>
            </v-avatar>
            <p
              class="mb-0"
            >{{item.active==0 ? $vuetify.lang.t('$vuetify.courseManagement.filterBar.disable') : $vuetify.lang.t('$vuetify.courseManagement.filterBar.publish')}}</p>
          </v-chip>-->
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-switch
                  color="rgb(66, 154, 216)"
                  inset
                  v-model="item.active"
                  @click="
                    $store.state.permission.activeCourse == true
                      ? openModalStatus(item)
                      : noPermission()
                  "
                ></v-switch>
              </div>
            </template>
            <span v-if="item.active">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.courseList.clickToSuspend'
                )
              }}
            </span>
            <span v-else>
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.courseList.clickToActivate'
                )
              }}
            </span>
          </v-tooltip>
        </template>
        <!--   <template v-slot:item.report="{ item }">
          <v-chip outlined class="mb-0 white--text" color="blue-grey" @click="setViewReport(item)">
            <v-avatar left>
              <v-icon>mdi-call-made</v-icon>
            </v-avatar>
            <p class="mb-0">{{$vuetify.lang.t('$vuetify.courseManagement.courseList.viewReport')}}</p>
          </v-chip>
        </template>-->
        <template v-slot:item.edit="{ item }">
          <div class="d-flex justify-center">
            <v-btn
              elevation="0"
              class="mb-0 px-1 body-2 text-primary text-capitalize"
              color="white"
              @click="viewReport(item)"
              >{{
                $vuetify.lang.t('$vuetify.courseManagement.courseList.report')
              }}</v-btn
            >

            <v-divider inset vertical class="mb-2 mx-1"></v-divider>
            <v-btn
              elevation="0"
              class="mb-0 px-1 body-2 text-primary text-capitalize"
              color="white"
              @click="editItem(item)"
            >
              <v-badge
                :offset-x="-1"
                :color="item.learnerRequest ? 'red' : 'transparent'"
              >
                <span slot="badge">{{ item.learnerRequest }}</span>
                <p class="mb-0">
                  {{
                    $vuetify.lang.t('$vuetify.courseManagement.courseList.edit')
                  }}
                </p>
              </v-badge>
            </v-btn>
            <v-divider
              inset
              vertical
              class="mb-2 mx-1"
              v-if="canDeleteCourse(item)"
            ></v-divider>

            <v-btn
              elevation="0"
              class="mb-0 px-1 body-2 error--text text-capitalize"
              color="white"
              @click="confirmDelete(item)"
              v-if="canDeleteCourse(item)"
            >
              <p class="mb-0">
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.delete'
                  )
                }}
              </p>
            </v-btn>
            <!-- <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  elevation="0"
                  class="mb-0 body-2 text-primary text-capitalize"
                  color="white"
                  v-on="on"
                >
                  <p
                    class="mb-0 mr-1"
                  >{{$vuetify.lang.t('$vuetify.courseManagement.courseList.more')}}</p>
                  <v-icon small>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item link @click="setChooseSection(item)">
                  <v-list-item-icon class="mr-2">
                    <v-icon small>mdi-cog-outline</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title
                      class="font-weight-light subtitle-2"
                    >{{$vuetify.lang.t("$vuetify.courseManagement.courseList.studentManagement")}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item link @click="setViewReport(item)">
                  <v-list-item-icon class="mr-2">
                    <v-icon small>mdi-text-box-check-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      class="font-weight-light subtitle-2"
                    >{{$vuetify.lang.t('$vuetify.courseManagement.courseList.viewReport')}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>-->
          </div>

          <!--  <v-chip outlined class="mb-0 white--text" color="blue-grey" @click="editItem(item)">
            <v-avatar left>
              <v-icon>mdi-pencil</v-icon>
            </v-avatar>
            <p class="mb-0">{{$vuetify.lang.t('$vuetify.courseManagement.courseList.edit')}}</p>
          </v-chip>-->
        </template>
        <!-- <template v-slot:item.actions="{ item }">
      
          <v-chip outlined class="mb-0 white--text" color="blue" @click="setChooseSection(item)">
            <v-avatar left>
              <v-icon>mdi-account-multiple</v-icon>
            </v-avatar>
            <p
              class="mb-0"
            >{{$vuetify.lang.t('$vuetify.courseManagement.courseList.studentManagement')}}</p>
          </v-chip>
        </template>-->
        <!-- <template v-slot:item.actions="{ item }"> -->
        <!-- <v-icon small class="mr-2" @click="openUserModal(item)">mdi-account-multiple</v-icon>!-->
        <!-- <v-icon small class="mr-2" @click="openSectionModal(item)">mdi-account-multiple</v-icon>
        <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>-->
        <!-- <v-icon small @click="openModal(item)">mdi-delete</v-icon> -->
        <!-- </template> -->
      </v-data-table>
      <v-dialog v-model="deleteDialog" max-width="350">
        <v-card class="pt-10">
          <!-- <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title> -->

          <v-card-text>
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.courseList.confirmDeleteItem'
              )
            }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="red darken-1" text @click="deleteDialog = false">
              {{ $vuetify.lang.t('$vuetify.cancel') }}
            </v-btn>

            <v-btn color="green darken-1" text @click="deleteItem">
              {{ $vuetify.lang.t('$vuetify.confirm') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-row justify="center">
        <v-dialog v-model="alert" persistent max-width="450">
          <v-card>
            <v-card-title class="headline">
              {{
                $vuetify.lang.t('$vuetify.courseManagement.courseList.sorry')
              }}
            </v-card-title>
            <v-card-text>
              <div
                v-html="
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.courseList.alertPermissionFunction'
                  )
                "
              ></div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" text @click="alert = false">
                {{ $vuetify.lang.t('$vuetify.courseManagement.courseList.ok') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <v-row justify="center">
        <v-dialog v-model="registerTutoralert" persistent max-width="450">
          <v-card>
            <div class="text-right">
              <v-btn icon class="ml-auto" @click="registerTutoralert = false">
                <v-icon color="primary">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <div v-show="isTeacher == 'n'">
                <!-- <div v-html="$vuetify.lang.t('$vuetify.courseManagement.courseList.alertPermissionTeacher')"></div>    -->
                <div
                  v-html="
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.courseList.alertPermissionTeacher'
                    )
                  "
                ></div>
                <!-- <div class="text-center mt-10">
                <v-btn rounded color="primary" @click="openConfirmDialog" dark>สมัครเป็นครู</v-btn>
                </div>-->
                <!-- </div> -->
                <!-- <div v-show="isTeacher=='n'">
                {{`${$vuetify.lang.t('$vuetify.dontHavePermisisonLong')} ${$vuetify.lang.t('$vuetify.requestTeacher')}`}}-->

                <div class="text-center mt-10">
                  <v-btn
                    rounded
                    color="primary"
                    @click="openConfirmDialog"
                    dark
                    >{{ $vuetify.lang.t('$vuetify.registerTeacher') }}</v-btn
                  >
                </div>
              </div>
              <div v-show="isTeacher == 'r'">
                <!-- การ
              <strong>&nbsp;สมัครเป็นครู&nbsp;</strong>ของบัญชีนี้
              <strong class="red--text">&nbsp;ไม่สำเร็จ&nbsp;</strong>
              <br />
              <br />
                <strong style="text-decoration:underline">เนื่องจาก</strong>-->
                <div
                  v-html="
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.courseList.alertRejectTeacher'
                    )
                  "
                ></div>
                &nbsp;
                {{ reject_note }}
                <br />
                <br />
                <!-- กรุณา
                <strong>&nbsp;สมัครเป็นครู&nbsp;</strong> ใหม่อีกครั้งเพื่อสามรถเข้าถึงรายการนี้-->
                <div
                  v-html="$vuetify.lang.t('$vuetify.requestTeacherAgain')"
                ></div>
                <div class="text-center mt-10">
                  <v-btn
                    rounded
                    color="primary"
                    @click="openConfirmDialog"
                    dark
                    >{{ $vuetify.lang.t('$vuetify.registerTeacher') }}</v-btn
                  >
                </div>
              </div>
              <div v-show="isTeacher == 'w'" class="mb-10">
                <v-card-title class="headline">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.courseList.sorry'
                    )
                  }}
                </v-card-title>
                <div
                  v-html="
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.courseList.alertNotAbleToAccess'
                    )
                  "
                ></div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
      <v-dialog v-model="selectSectionDialog" max-width="600">
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title>
              <v-icon left>mdi-vector-polyline-edit</v-icon>
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.courseList.chooseStudyingGroup'
                )
              }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeSectionModal">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-container fluid class="my-5">
            <v-data-table
              :headers="section_headers"
              :items="section_data"
              :items-per-page="20"
              hide-default-footer
              class="boder elevation-0"
            >
              <template v-slot:item.teacher="{ item }">
                <p class="ma-0">{{ item.teacher.displayName }}</p>
              </template>
              <template v-slot:item.select="{ item }">
                <!-- <v-icon small class="mr-2" @click="userEdit(item)">mdi-pencil</v-icon> -->
                <v-chip
                  outlined
                  class="mb-0 white--text"
                  :color="chooseRoom == true ? 'blue-grey' : 'primary'"
                  @click="
                    chooseRoom == true
                      ? openDialogGetReport(item)
                      : openUserModal(item)
                  "
                >
                  <v-avatar left>
                    <v-icon>
                      {{ chooseRoom == true ? 'mdi-call-made' : 'mdi-plus' }}
                    </v-icon>
                  </v-avatar>
                  <p class="mb-0">
                    {{
                      chooseRoom == true
                        ? $vuetify.lang.t(
                            '$vuetify.courseManagement.courseList.viewReport'
                          )
                        : $vuetify.lang.t(
                            '$vuetify.courseManagement.courseList.addStudent'
                          )
                    }}
                  </p>
                </v-chip>
              </template>
            </v-data-table>
            <!--<div class="text-center pt-2">
            <v-pagination v-model="page_section" :length="1"></v-pagination>
            </div>-->
          </v-container>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              class="px-10 ma-2"
              rounded
              dark
              @click="closeSectionModal"
              >{{ $vuetify.lang.t('$vuetify.defaultLayout.dismiss') }}</v-btn
            >
            <!-- <v-btn color="green darken-1" text @click="openUserModal">OK</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>
      <import-user-dialog
        :isOpen.sync="userDialog"
        :isClose="CloseUserModal"
        :courseId.sync="manageUserCourseID"
        :sectionID.sync="roomID"
      ></import-user-dialog>
      <confirm-tutor-dialog
        :isOpen.sync="confirmDialog"
        :isClose="closeConfirmDialog"
      ></confirm-tutor-dialog>

      <v-row justify="center">
        <v-dialog
          v-model="dialogFullReport"
          fullscreen
          persistent
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card class="main">
            <v-toolbar flat dark color="rgb(51, 97, 137)">
              <v-toolbar-title>
                <v-icon left>mdi-finance</v-icon>
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.courseList.studentListInCourse'
                  )
                }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="closeDialogFullReport">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <div>
                <v-row>
                  <v-col
                    class="display-1 font-weight-medium black--text mx-5 mt-5"
                    >Learner List of the Course</v-col
                  >
                </v-row>
                <v-row class="pa-5 pt-0 mt-0 pb-0 mb-0 align-center">
                  <v-col cols="2" class="pt-0 mt-0">
                    <v-card max-width="200">
                      <v-img
                        class="rounded-card"
                        height="100"
                        :src="imageCourse == null ? imageReady : imageCourse"
                      >
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center">
                            <v-icon
                              v-if="imageReady"
                              class="my-2 rounded-card"
                              elevation="3"
                              size="80"
                              >mdi-image-area</v-icon
                            >
                          </v-row>
                        </template>
                      </v-img>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-col class="headline black--text py-0">{{ title }}</v-col>
                    <!-- <v-col class="subtitle-1 font-weight-light pb-0">
                      Number of Learners:
                      <span
                        class="font-weight-light ml-3 font-italic"
                      >{{ reportStudentList.length }}</span>
                    </v-col>-->
                    <!-- <v-col class="subtitle-1 font-weight-light py-0">
                      Room Name:
                      <span class="font-weight-light ml-3 font-italic">{{ roomTitle }}</span>
                    </v-col>-->
                    <v-col class="subtitle-1 font-weight-medium pb-1">
                      <span class="black--text">Instructor:</span>
                      <span class="font-weight-light ml-3 font-italic">
                        {{ instructorName }}
                      </span>
                    </v-col>
                    <v-col class="subtitle-1 font-weight-medium py-0 d-flex">
                      <span class="black--text mt-1">Classroom:</span>
                      <v-col
                        class="subtitle-2 font-weight-light py-0 ml-3"
                        cols="3"
                      >
                        <v-select
                          :items="roomsCourse"
                          v-model="selectedRoom"
                          outlined
                          background-color="#fff"
                          height="40"
                          @change="onChangeRoom()"
                        ></v-select>
                      </v-col>
                    </v-col>
                  </v-col>
                </v-row>
                <v-row class="pa-5 pt-0 mt-0 pb-0 mb-0">
                  <v-col :lg="5" cols="12" class="pt-0">
                    <v-row>
                      <v-col :lg="6" :md="6" :sm="12" cols="12" class="pt-0">
                        <div class="stat-num stat-num-top px-1">
                          <v-col class="d-flex py-0">
                            <v-icon class="mr-1 white--text" large
                              >check_circle</v-icon
                            >
                            <v-col>
                              <v-col class="pa-0">COMPLETED</v-col>
                              <v-col class="pa-0">(สำเร็จ)</v-col>
                            </v-col>
                          </v-col>
                          <v-row
                            class="d-flex align-end mx-1 font-weight-light"
                          >
                            <v-col class="text-end pt-0">
                              <span class="display-1 font-weight-light">
                                {{ completedUser }}
                              </span>
                              <br />users
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>
                      <v-col :lg="6" :md="6" :sm="12" cols="12" class="pt-0">
                        <div class="stat-num stat-num-not-completed px-1">
                          <v-col class="d-flex py-0">
                            <v-icon class="mr-1 white--text" large
                              >warning</v-icon
                            >
                            <v-col>
                              <v-col class="pa-0">NOT COMPLETED</v-col>
                              <v-col class="pa-0">(ยังไม่สำเร็จ)</v-col>
                            </v-col>
                          </v-col>
                          <v-row
                            class="d-flex align-end mx-1 font-weight-light"
                          >
                            <v-col class="text-end pt-0">
                              <span class="display-1 font-weight-light">
                                {{ notCompletedUser }}
                              </span>
                              <br />users
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row class="align-center">
                      <v-col :lg="12" :md="12" :sm="12" cols="12" class="pa-3">
                        <apexchart
                          type="radialBar"
                          height="400"
                          :options="chartOptionsAngleCircle"
                          :series="seriesAngleCircle"
                        ></apexchart>
                      </v-col>
                    </v-row>
                    <!-- <v-row class="justify-center">
                      <v-col :lg="10" :md="10" :sm="10" cols="12" class="pa-3">
                        <apexchart
                          type="donut"
                          width="100%"
                          :options="chartOptionsLearningProgress"
                          :series="seriesLearningProgress"
                        ></apexchart>
                      </v-col>
                    </v-row>
                    <v-row class="justify-center">
                      <v-col :lg="9" :md="9" :sm="9" cols="12" class="pa-3">
                        <apexchart
                          type="donut"
                          width="100%"
                          :options="chartOptions"
                          :series="series"
                        ></apexchart>
                      </v-col>
                    </v-row>-->
                  </v-col>
                  <v-col :lg="7" cols="12" class="pt-0">
                    <v-row>
                      <v-col
                        :lg="4"
                        :md="4"
                        :sm="12"
                        cols="12"
                        class="pa-3 pt-0"
                      >
                        <div class="stat-num stat-num-total px-1">
                          <v-col class="d-flex py-0">
                            <v-icon class="mr-1 white--text" large
                              >assignment_ind</v-icon
                            >
                            <v-col>
                              <v-col class="pa-0">TOTAL</v-col>
                              <v-col class="pa-0">(เรียนทั้งหมด)</v-col>
                            </v-col>
                          </v-col>
                          <v-row
                            class="d-flex align-end mx-1 font-weight-light"
                          >
                            <v-col class="text-end pt-0">
                              <span class="display-1 font-weight-light">
                                {{ totalUser }}
                              </span>
                              <br />users
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>
                      <v-col
                        :lg="4"
                        :md="4"
                        :sm="12"
                        cols="12"
                        class="pa-3 pt-0"
                      >
                        <div class="stat-num stat-num-today px-1">
                          <v-col class="d-flex py-0">
                            <v-icon class="mr-1 white--text" large
                              >today</v-icon
                            >
                            <v-col>
                              <v-col class="pa-0">TODAY</v-col>
                              <v-col class="pa-0">(เข้าเรียนวันนี้)</v-col>
                            </v-col>
                          </v-col>
                          <v-row
                            class="d-flex align-end mx-1 font-weight-light"
                          >
                            <v-col class="text-end pt-0">
                              <span class="display-1 font-weight-light">
                                {{ userToday }}
                              </span>
                              <br />users
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>
                      <v-col
                        :lg="4"
                        :md="4"
                        :sm="12"
                        cols="12"
                        class="pa-3 pt-0"
                      >
                        <div class="stat-num stat-num-online px-1">
                          <v-col class="d-flex py-0">
                            <v-icon class="mr-1 white--text" large
                              >toggle_on</v-icon
                            >
                            <v-col>
                              <v-col class="pa-0">ONLINE</v-col>
                              <v-col class="pa-0">(กำลังเรียน)</v-col>
                            </v-col>
                          </v-col>
                          <v-row
                            class="d-flex align-end mx-1 font-weight-light"
                          >
                            <v-col class="text-end pt-0">
                              <span class="display-1 font-weight-light">
                                {{ onlineUser }}
                              </span>
                              <br />users
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row class="align-center justify-center">
                      <v-col :lg="12" :md="12" :sm="12" cols="12" class="pa-3">
                        <div class="graph-card pa-5 pt-3">
                          <v-col>
                            <v-col
                              class="pr-2 d-flex justify-between align-end"
                            >
                              <span class="headline font-weight-light"
                                >Learner</span
                              >
                            </v-col>
                            <apexchart
                              type="area"
                              height="320"
                              :options="overallChartOptions"
                              :series="overallSeries"
                            ></apexchart>
                          </v-col>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <!-- <v-col lg="3" md="3" cols="12">
                    <div class="md-border pa-5 ma-5">
                      <div class="filter-header">
                        <p class="title mb-0 py-1">
                          <v-icon left>mdi-filter</v-icon>
                          {{$vuetify.lang.t('$vuetify.courseManagement.courseList.filter')}}
                        </p>
                        <div class="text-right py-1">
                          <v-btn
                            rounded
                            outlined
                            color="primary"
                            dark
                          >{{$vuetify.lang.t('$vuetify.courseManagement.courseList.clearFilter')}}</v-btn>
                        </div>
                      </div>
                      <div class="filter-body my-5">
                        <v-expansion-panels v-model="panel" multiple>
                          <v-expansion-panel class="mb-5">
                            <v-expansion-panel-header>{{$vuetify.lang.t('$vuetify.courseManagement.courseList.progress')}}</v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <div>
                                <p>{{$vuetify.lang.t('$vuetify.courseManagement.courseList.accomplishment')}}</p>
                                <v-row>
                                  <v-col class="px-4">
                                    <v-range-slider
                                      v-model="range"
                                      :max="max"
                                      :min="min"
                                      hide-details
                                      class="align-center"
                                    >
                                      <template v-slot:prepend>
                                        <v-text-field
                                          :value="range[0]"
                                          class="mt-0 pt-0"
                                          hide-details
                                          single-line
                                          type="number"
                                          style="width: 60px"
                                          @change="$set(range, 0, $event)"
                                        ></v-text-field>
                                      </template>
                                      <template v-slot:append>
                                        <v-text-field
                                          :value="range[1]"
                                          class="mt-0 pt-0"
                                          hide-details
                                          single-line
                                          type="number"
                                          style="width: 60px"
                                          @change="$set(range, 1, $event)"
                                        ></v-text-field>
                                      </template>
                                    </v-range-slider>
                                  </v-col>
                                </v-row>
                              </div>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel class="mb-5">
                            <v-expansion-panel-header>{{$vuetify.lang.t('$vuetify.courseManagement.exam.examination')}}</v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <div>
                                <p>{{$vuetify.lang.t('$vuetify.courseManagement.exam.chooseExamination')}}</p>
                                <v-checkbox
                                  class="my-0"
                                  v-model="exam_select"
                                  :label="$vuetify.lang.t('$vuetify.courseManagement.exam.examination1')"
                                  value="John"
                                ></v-checkbox>
                                <v-checkbox
                                  class="my-0"
                                  v-model="exam_select"
                                  :label="$vuetify.lang.t('$vuetify.courseManagement.exam.examination2')"
                                  value="Jacob"
                                ></v-checkbox>
                              </div>
                              <v-divider class="my-5"></v-divider>
                              <div>
                                <p>{{$vuetify.lang.t('$vuetify.courseManagement.exam.examinationStatus')}}</p>
                                <v-radio-group v-model="radios" :mandatory="false">
                                  <v-radio
                                    :label="$vuetify.lang.t('$vuetify.courseManagement.exam.all')"
                                    value="ทั้งหมด"
                                  ></v-radio>
                                  <v-radio
                                    :label="$vuetify.lang.t('$vuetify.courseManagement.exam.neverDoExamination')"
                                    value="no"
                                  ></v-radio>
                                  <v-radio
                                    :label="$vuetify.lang.t('$vuetify.courseManagement.exam.haveDoneExamination')"
                                    value="was"
                                  ></v-radio>
                                </v-radio-group>
                              </div>

                              <v-divider class="my-5"></v-divider>
                              <div>
                                <p>{{$vuetify.lang.t('$vuetify.courseManagement.exam.score')}}</p>
                                <v-row>
                                  <v-col class="px-4">
                                    <v-range-slider
                                      v-model="range"
                                      :max="max"
                                      :min="min"
                                      hide-details
                                      class="align-center"
                                    >
                                      <template v-slot:prepend>
                                        <v-text-field
                                          :value="range[0]"
                                          class="mt-0 pt-0"
                                          hide-details
                                          single-line
                                          type="number"
                                          style="width: 60px"
                                          @change="$set(range, 0, $event)"
                                        ></v-text-field>
                                      </template>
                                      <template v-slot:append>
                                        <v-text-field
                                          :value="range[1]"
                                          class="mt-0 pt-0"
                                          hide-details
                                          single-line
                                          type="number"
                                          style="width: 60px"
                                          @change="$set(range, 1, $event)"
                                        ></v-text-field>
                                      </template>
                                    </v-range-slider>
                                  </v-col>
                                </v-row>
                              </div>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </div>
                      <div class="text-center">
                        <v-btn rounded color="primary" dark>
                          <v-icon left>mdi-filter</v-icon>
                          {{$vuetify.lang.t('$vuetify.courseManagement.courseList.filter')}}
                        </v-btn>
                      </div>
                    </div>
                  </v-col>-->
                  <v-toolbar
                    flat
                    style="background: transparent"
                    color="table-header pa-0"
                  >
                    <v-col cols="3" class="ma-md-5 px-0 xs-full-width">
                      <span class="caption title-text font-weight-black"
                        >SEARCH</span
                      >
                      <v-text-field
                        class="text-field-border"
                        solo
                        flat
                        dense
                        v-model="searchdataStudent"
                        @change="searchInfoStudent(searchdataStudent)"
                        :placeholder="
                          $vuetify.lang.t('$vuetify.courseManagement.search')
                        "
                        clearable
                      ></v-text-field>
                    </v-col>
                    <div class="mr-md-3 ml-7">
                      <div class="mr-md-5 xs-full-width">
                        <div class="caption font-weight-black title-text">
                          STATUS
                        </div>
                        <v-btn-toggle
                          color="primary accent-3"
                          background-color="white"
                          mandatory
                          v-model="status_student_toggle"
                          @change="applyStudentFilter"
                        >
                          <v-btn
                            class="text-capitalize body-2 px-12"
                            height="40px"
                            >All</v-btn
                          >
                          <v-btn
                            class="text-capitalize body-2 px-8"
                            height="40px"
                            >Started ({{ countStartedStudents.length }})</v-btn
                          >
                          <v-btn
                            class="text-capitalize body-2 px-3"
                            height="40px"
                          >
                            Not Started ({{ countNotStartedStudents.length }})
                          </v-btn>
                        </v-btn-toggle>
                      </div>
                    </div>
                    <div class="ml-5 xs-full-width mt-12">
                      <v-btn
                        height="40px"
                        elevation="0"
                        back
                        outlined
                        @click="refreshStudent"
                        class="
                          mb-7
                          pl-6
                          pr-5
                          xs-full-width
                          body-2
                          text-field-border
                        "
                      >
                        <v-icon left>mdi-cached</v-icon>
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.filterBar.refresh'
                          )
                        }}
                      </v-btn>
                    </div>
                  </v-toolbar>
                  <v-col lg="12" md="12" cols="12">
                    <v-data-table
                      :loading="loading"
                      :headers="headerStudents"
                      :page.sync="page_student"
                      :items-per-page="limit_student"
                      @page-count="pageCount_student"
                      hide-default-footer
                      :items="reportStudentList"
                      class="ma-md-5 pt-0 mt-0 font-weight-light"
                      elevation="3"
                    >
                      <template v-slot:item.image="{ item }">
                        <!-- <v-avatar :color="`grey lighten-2`" elevation="3" size="60" class="my-2"> -->
                        <v-img
                          :src="item.image == null ? imageReady : item.image"
                          class="my-2 ml-auto mr-auto rounded-card img-md"
                          aspect-ratio="1"
                          width="60"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-icon
                                v-if="imageReady"
                                class="mx-auto"
                                elevation="3"
                                size="65"
                                >mdi-account</v-icon
                              >
                            </v-row>
                          </template>
                        </v-img>
                        <!-- </v-avatar> -->
                      </template>
                      <template v-slot:item.fullName="{ item }">
                        <p
                          class="
                            ma-2
                            ml-0
                            md-fixed-width
                            text-left
                            subtitle-2
                            font-weight-light
                          "
                        >
                          {{ item.fullName }}
                        </p>
                      </template>
                      <template v-slot:item.progress="{ item }">
                        <div
                          v-if="item.percent == 100"
                          class="d-flex align-center"
                        >
                          <v-progress-linear
                            :value="item.percent"
                            color="success lighten-1"
                            rounded
                            height="8"
                            reactive
                          ></v-progress-linear>
                          <v-icon small color="success lighten-1" class="ml-3"
                            >mdi-check-circle</v-icon
                          >
                        </div>

                        <div v-else class="d-flex align-center">
                          <v-progress-linear
                            :value="item.percent"
                            background-color="grey lighten-4"
                            color="primary lighten-1"
                            rounded
                            height="8"
                            reactive
                          ></v-progress-linear>
                          <span class="font-weight-light subtitle-2 ml-3"
                            >{{ item.percent }}%</span
                          >
                        </div>
                      </template>
                      <!-- <template v-slot:item.email="{ item }">
                        <p class="ma-2 md-fixed-width text-left">{{item.email}}</p>
                      </template>
                      <template v-slot:item.userName="{ item }">
                        <p class="ma-2 md-fixed-width text-left">{{item.userName}}</p>
                      </template>
                      <template v-slot:item.room="{ item }">
                        <v-chip-group column class="md-fixed-max-width">
                          <v-chip small class="ma-2">
                            <p class="mb-0">{{ item.room }}</p>
                          </v-chip>
                        </v-chip-group>
                      </template>-->
                      <template v-slot:item.report="{ item }">
                        <v-chip
                          outlined
                          label
                          small
                          class="mb-0"
                          color="primary lighten-1"
                          @click="viewProgressReport(item)"
                        >
                          <v-avatar left>
                            <v-icon small>mdi-equalizer</v-icon>
                          </v-avatar>
                          <span class="mb-0">
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.courseList.seeReport'
                              )
                            }}
                          </span>
                        </v-chip>
                      </template>
                      <!-- <template v-slot:item.actions="{ item }">
                        <v-chip
                          outlined
                          label
                          class="mb-0 white--text"
                          color="blue-grey"
                          @click="userEdit(item)"
                        >
                          <v-avatar left>
                            <v-icon>mdi-eye</v-icon>
                          </v-avatar>
                          <p
                            class="mb-0"
                          >{{$vuetify.lang.t('$vuetify.courseManagement.exam.seeData')}}</p>
                        </v-chip>
                      </template>-->
                    </v-data-table>

                    <v-row justify="center">
                      <v-dialog v-model="alert" persistent max-width="450">
                        <v-card>
                          <v-card-title class="headline">
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.courseList.sorry'
                              )
                            }}
                          </v-card-title>
                          <v-card-text>
                            <div
                              v-html="
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.courseList.alertPermissionFunction'
                                )
                              "
                            ></div>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="primary darken-1"
                              text
                              @click="alert = false"
                            >
                              {{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.courseList.ok'
                                )
                              }}
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-row>
                    <div class="text-center">
                      <v-pagination
                        v-model="page_student"
                        :length="pageCount_student"
                        @input="changePageStudent"
                        color="rgb(66, 154, 216)"
                      ></v-pagination>
                    </div>
                  </v-col>
                </v-row>

                <v-dialog v-model="dialogFormUser" scrollable max-width="800px">
                  <v-card>
                    <v-toolbar flat dark color="rgb(51, 97, 137)">
                      <v-spacer></v-spacer>
                      <v-toolbar-title
                        class="font-weight-light text-center ml-5"
                      >
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.courseList.studentInformation'
                          )
                        }}
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn icon dark @click="dialogFormUser = false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card-text class>
                      <v-form ref="form" v-model="valid">
                        <v-container>
                          <v-row>
                            <v-col cols="12" class="mx-auto">
                              <div class="img-padding">
                                <v-avatar
                                  :color="`grey lighten-2`"
                                  elevation="3"
                                  size="200"
                                >
                                  <v-img
                                    :src="
                                      imgPreview == null
                                        ? imageReady
                                        : imgPreview
                                    "
                                    aspect-ratio="1.8"
                                  >
                                    <template v-slot:placeholder>
                                      <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                      >
                                        <v-icon
                                          v-if="imageReady"
                                          class="mx-auto"
                                          elevation="3"
                                          size="200"
                                          >mdi-account</v-icon
                                        >
                                      </v-row>
                                    </template>
                                  </v-img>
                                </v-avatar>
                              </div>
                              <v-divider class="mt-6"></v-divider>
                            </v-col>
                            <v-col cols="12">
                              <div
                                class="
                                  text-center
                                  display-1
                                  font-weight-regular
                                "
                              >
                                {{ firstName }} {{ lastName }}
                              </div>
                            </v-col>
                            <v-col cols="12" class="pb-0 mt-5">
                              <div class="text-center title font-weight-light">
                                <strong>
                                  {{
                                    $vuetify.lang.t(
                                      '$vuetify.defaultLayout.email'
                                    )
                                  }}
                                  :
                                </strong>
                                {{ email }}
                              </div>
                            </v-col>
                            <v-col cols="12" class="py-0">
                              <div class="text-center title font-weight-light">
                                <strong>
                                  {{
                                    $vuetify.lang.t(
                                      '$vuetify.defaultLayout.username'
                                    )
                                  }}
                                  :
                                </strong>
                                {{ username }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-form>
                    </v-card-text>
                    <v-divider></v-divider>
                    <!-- <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        class="px-10 ma-2"
                        large
                        rounded
                        @click="dialogFormUser = false"
                      >{{$vuetify.lang.t('$vuetify.courseManagement.close')}}</v-btn>
                    </v-card-actions>-->

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        elevation="0"
                        class="
                          px-10
                          ma-2
                          subtitle-1
                          text-capitalize
                          font-weight-light
                          button-primary
                        "
                        @click="dialogFormUser = false"
                      >
                        {{ $vuetify.lang.t('$vuetify.courseManagement.close') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog
                  v-model="dialogViewReport"
                  scrollable
                  max-width="900px"
                >
                  <v-card>
                    <v-toolbar flat dark color="rgb(51, 97, 137)">
                      <v-spacer></v-spacer>
                      <v-toolbar-title
                        class="
                          font-weight-light
                          text-center
                          ml-5
                          text-capitalize
                        "
                      >
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.courseList.progressReport'
                          )
                        }}
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn icon dark @click="closeDialogViewReport">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card-text class="px-0">
                      <v-container class="d-flex">
                        <v-col cols="5" class="px-5 pr-7">
                          <v-img
                            :src="image == null ? imageReady : image"
                            class="my-2 ml-auto mr-auto rounded-card img-md"
                            aspect-ratio="1"
                            width="100%"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-icon
                                  v-if="imageReady"
                                  class="mx-auto"
                                  elevation="3"
                                  size="80"
                                  >mdi-account</v-icon
                                >
                              </v-row>
                            </template>
                          </v-img>
                          <v-row>
                            <v-col>
                              <span class="font-weight-bold title">
                                {{ fullName }}
                              </span>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col class="py-0 font-weight-bold" cols="4"
                              >Username:</v-col
                            >
                            <v-col class="py-0">
                              <span class="subtitle font-weight-light">
                                {{ userName }}
                              </span>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col class="py-0 font-weight-bold" cols="4"
                              >Email:</v-col
                            >
                            <v-col class="py-0">
                              <span class="subtitle font-weight-light">
                                {{ email }}
                              </span>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col class="py-0 font-weight-bold" cols="4"
                              >Phone:</v-col
                            >
                            <v-col class="py-0">
                              <span class="subtitle font-weight-light">
                                {{ tel }}
                              </span>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col class="py-0 font-weight-bold" cols="4"
                              >Birthdate:</v-col
                            >
                            <v-col class="py-0">
                              <span class="subtitle font-weight-light">
                                {{ birthdate }}
                              </span>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col class="py-0 font-weight-bold" cols="4"
                              >Gender:</v-col
                            >
                            <v-col class="py-0">
                              <span class="subtitle font-weight-light">
                                {{ gender }}
                              </span>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="7" class="px-0 pr-5">
                          <v-col cols="12" class="px-0 py-0">
                            <!-- <v-row class="mx-1">
                              <p
                                class="font-weight-bold black--text title text-capitalize pb-0 mb-0"
                              >{{$vuetify.lang.t('$vuetify.courseManagement.courseList.progressReport')}}</p>
                            </v-row>-->
                            <v-row class="mx-1">
                              <h3
                                class="
                                  font-weight-bold
                                  text-capitalize
                                  py-0
                                  my-0
                                "
                              >
                                Course: {{ historyList.title }}
                              </h3>
                            </v-row>
                            <!-- <v-row class="mx-1">
                                                        <p class="font-weight-light subtitle-2 py-0 my-0" v-html="historyList.description" />
                            </v-row>-->

                            <v-row
                              class="mt-5"
                              v-for="(
                                section, sectionIndex
                              ) in historyList.learningSectionHis"
                              :key="sectionIndex"
                            >
                              <v-col class="py-0 mx-1">
                                <p
                                  class="
                                    subtitle-2
                                    font-weight-bold
                                    black--text
                                  "
                                >
                                  Lesson {{ sectionIndex + 1 }}:
                                  {{ section.title }}
                                </p>
                              </v-col>
                              <v-col
                                class="py-0"
                                cols="12"
                                v-for="(
                                  lecture, lectureIndex
                                ) in section.lectures"
                                :key="lectureIndex"
                              >
                                <div class="d-flex align-center">
                                  <div class="pr-3">
                                    <v-icon v-if="lecture.type === 'PDF'"
                                      >mdi-adobe-acrobat</v-icon
                                    >
                                    <v-icon v-else-if="lecture.type === 'EXAM'"
                                      >mdi-file-document-outline</v-icon
                                    >
                                    <v-icon v-else-if="lecture.type === 'BOOK'"
                                      >mdi-book-open-page-variant</v-icon
                                    >
                                    <v-icon v-else-if="lecture.type === 'VDO'"
                                      >mdi-bell-ring-outline</v-icon
                                    >
                                    <v-icon
                                      v-else-if="lecture.type === 'YOUTUBE'"
                                      >mdi-youtube</v-icon
                                    >
                                    <v-icon v-else-if="lecture.type === 'BLOG'"
                                      >mdi-blogger</v-icon
                                    >
                                    <v-icon v-else-if="lecture.type === 'IMG'"
                                      >mdi-image-size-select-actual</v-icon
                                    >
                                    <v-icon v-else-if="lecture.type === 'FILE'"
                                      >mdi-paperclip</v-icon
                                    >
                                    <v-icon v-else-if="lecture.type === 'URL'"
                                      >mdi-link</v-icon
                                    >
                                  </div>

                                  <v-col>
                                    <v-row class="py-0">
                                      <span class="subtitle-2 font-weight-bold">
                                        Lecture {{ lectureIndex + 1 }}:
                                        {{ lecture.title }}
                                      </span>
                                    </v-row>
                                    <v-row
                                      class="
                                        d-flex
                                        justify-between
                                        align-center
                                        py-0
                                      "
                                    >
                                      <span>{{ lecture.type }}</span>
                                      <v-spacer></v-spacer>
                                      <v-col class="text-right py-0 px-0">
                                        <v-btn
                                          :disabled="lecture.percent <= 0"
                                          v-if="lecture.type === 'EXAM'"
                                          class="
                                            mb-0
                                            body-2
                                            text-primary text-capitalize
                                          "
                                          outlined
                                          @click="
                                            examTitle = lecture.title;
                                            dialogExamReport = true;
                                            getReportStudentExamScore(
                                              lecture.exam
                                            );
                                          "
                                          >Detail</v-btn
                                        >
                                      </v-col>
                                    </v-row>
                                    <v-row
                                      v-if="lecture.percent == 100"
                                      class="align-center"
                                    >
                                      <v-col
                                        class="d-flex px-0 py-0 align-center"
                                      >
                                        <v-progress-linear
                                          :value="lecture.percent"
                                          color="success lighten-1"
                                          rounded
                                          height="8"
                                          reactive
                                        ></v-progress-linear>
                                        <v-icon
                                          small
                                          color="success lighten-1"
                                          class="ml-1"
                                          >mdi-check-circle</v-icon
                                        >
                                      </v-col>
                                    </v-row>
                                    <v-row v-else class="py-0 align-center">
                                      <v-col
                                        class="d-flex px-0 py-0 align-center"
                                      >
                                        <v-progress-linear
                                          :value="lecture.percent"
                                          color="rgb(66, 154, 216)"
                                          background-color="grey lighten-3"
                                          rounded
                                          height="7"
                                          reactive
                                        ></v-progress-linear>
                                        <span class="ml-1"
                                          >{{ lecture.percent }}%</span
                                        >
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </div>
                              </v-col>
                              <v-divider></v-divider>
                            </v-row>

                            <!-- <v-row class="pa-3">
                              <p
                                class="px-3 pt-3 font-weight-bold"
                              >{{$vuetify.lang.t('$vuetify.courseManagement.courseList.exam')}}</p>
                              <v-spacer></v-spacer>
                              <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                  <json-excel :data="dataForExcel" :name="fileExcelName">
                                    <v-chip
                                      v-on="on"
                                      outlined
                                      class="mb-0 px-7 mx-3 white--text"
                                      color="teal"
                                    >
                                      <v-avatar left>
                                        <v-icon>mdi-file-download-outline</v-icon>
                                      </v-avatar>
                                      <p class="mb-0 font-weight-light subtitle-2">Excel</p>
                                    </v-chip>
                                  </json-excel>
                                </template>
                                <div>
                                  <span
                                    class="px-3"
                                  >{{$vuetify.lang.t('$vuetify.courseManagement.exam.downloadexaminationRecord')}}</span>
                                </div>
                              </v-tooltip>
                              <p class="px-3 pt-3">{{ this.historyList.avgPercentAll }}%</p>

                              <v-col cols="12" class="py-0">
                                <v-progress-linear
                                  :value="knowledge"
                                  color="rgb(66, 154, 216)"
                                  rounded
                                  height="15"
                                  reactive
                                ></v-progress-linear>
                              </v-col>
                              <v-col cols="12" class="my-0 py-0">
                                <v-card outlined class="mt-5">
                                  <v-slide-group
                                    v-model="statChart"
                                    class="py-4 px-0"
                                    center-active
                                    show-arrows
                                  >
                                    <v-slide-item
                                      v-for="n in historyExamList"
                                      :key="n"
                                      v-slot:default="{ active, toggle }"
                                    >
                                      <v-card
                                        outlined
                                        class="pa-3 ma-3"
                                        @click="toggle"
                                        width="100%"
                                      >
                                        <p class="pa-3 title">{{ n.hisExamTitle }}</p>

                                        <vue-apex-charts
                                          type="line"
                                          width="700px"
                                          :options="n.chartOptions"
                                          :series="n.series"
                                          :hidden="n.hisScore.length ? false : true"
                                        ></vue-apex-charts>
                                        <p
                                          class="pl-3 title"
                                          :hidden="n.hisScore.length ? true : false"
                                        >{{$vuetify.lang.t('$vuetify.courseManagement.exam.noExaminationRecord')}}</p>

                                        <v-card-text class="pt-3 pb-0">
                                          <div
                                            v-html="$vuetify.lang.t('$vuetify.courseManagement.exam.OverallExamScore')"
                                          ></div>
                                          <div
                                            v-html="$vuetify.lang.t('$vuetify.courseManagement.exam.YaxisXaxis')"
                                          ></div>

                                          <v-divider class="my-2"></v-divider>
                                        </v-card-text>
                                        <v-row class="pa-3">
                                          <p
                                            class="px-3"
                                          >{{$vuetify.lang.t('$vuetify.courseManagement.exam.averageScore')}}</p>
                                          <v-spacer></v-spacer>
                                          <p class="px-3">100</p>
                                          <v-col cols="12">
                                            <v-progress-linear
                                              :value="n.hisAvg"
                                              color="rgb(66, 154, 216)"
                                              rounded
                                              height="16"
                                              reactive
                                            >{{ n.hisAvg }}</v-progress-linear>
                                          </v-col>
                                        </v-row>
                                      </v-card>
                                    </v-slide-item>
                                  </v-slide-group>
                                </v-card>
                              </v-col>
                            </v-row>-->
                          </v-col>
                        </v-col>
                      </v-container>
                      <!-- <v-card class="my-5">
                        <v-card-title class="headline pa-2">
                          <v-icon
                            class="pr-3"
                            color="success"
                            size="28"
                          >mdi-checkbox-marked-circle-outline</v-icon>
                          {{$vuetify.lang.t('$vuetify.courseManagement.success')}}
                        </v-card-title>
                        <v-row class="pa-3">
                          <p
                            class="px-3"
                          >{{$vuetify.lang.t('$vuetify.courseManagement.courseList.accomplishment')}}</p>
                          <v-spacer></v-spacer>
                          <p class="px-3">{{ this.historyList.avgPercentAll }}%</p>
                          <v-col cols="12">
                            <v-progress-linear
                              :value="knowledge"
                              color="success"
                              rounded
                              height="20"
                              reactive
                            ></v-progress-linear>
                          </v-col>
                        </v-row>
                      </v-card>

                      <v-card class="my-5">
                        <v-card-title class="headline pa-2">
                          <v-icon class="pr-3" color="red" size="28">mdi-circle-edit-outline</v-icon>
                          {{$vuetify.lang.t('$vuetify.courseManagement.exam.examinationRecord')}}
                        </v-card-title>
                        <v-row class="pa-3">
                          <p
                            class="px-3 my-1"
                          >{{$vuetify.lang.t('$vuetify.courseManagement.exam.downloadexaminationRecord')}}</p>
                          <v-spacer></v-spacer>
                          <div class="px-3">
                            <json-excel :data="dataForExcel" :name="fileExcelName">
                              <v-chip outlined class="mb-0 white--text" color="teal">
                                <v-avatar left>
                                  <v-icon>mdi-file-download-outline</v-icon>
                                </v-avatar>
                                <p class="mb-0">Excel</p>
                              </v-chip>
                            </json-excel>
                          </div>
                        </v-row>
                        <v-row class="px-3 align-center">
                          <v-col cols="12">
                            <v-slide-group
                              v-model="statChart"
                              class="pa-4"
                              center-active
                              show-arrows
                            >
                              <v-slide-item
                                v-for="n in historyExamList"
                                :key="n"
                                v-slot:default="{ active, toggle }"
                              >
                                <v-card outlined class="pa-3 ma-3" @click="toggle" width="750px">
                                  <p class="pa-3 title">{{ n.hisExamTitle }}</p>

                                  <vue-apex-charts
                                    type="line"
                                    width="700px"
                                    :options="n.chartOptions"
                                    :series="n.series"
                                    :hidden="n.hisScore.length ? false : true"
                                  ></vue-apex-charts>
                                  <p
                                    class="pl-3 title"
                                    :hidden="n.hisScore.length ? true : false"
                                  >{{$vuetify.lang.t('$vuetify.courseManagement.exam.noExaminationRecord')}}</p>

                                  <v-card-text class="pt-3 pb-0">
                                    <div
                                      v-html="$vuetify.lang.t('$vuetify.courseManagement.exam.OverallExamScore')"
                                    ></div>
                                    <div
                                      v-html="$vuetify.lang.t('$vuetify.courseManagement.exam.YaxisXaxis')"
                                    ></div>

                                    <v-divider class="my-2"></v-divider>
                                  </v-card-text>
                                  <v-row class="pa-3">
                                    <p
                                      class="px-3"
                                    >{{$vuetify.lang.t('$vuetify.courseManagement.exam.averageScore')}}</p>
                                    <v-spacer></v-spacer>
                                    <p class="px-3">100</p>
                                    <v-col cols="12">
                                      <v-progress-linear
                                        :value="n.hisAvg"
                                        color="light-blue"
                                        rounded
                                        height="16"
                                        reactive
                                      >{{ n.hisAvg }}</v-progress-linear>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-slide-item>
                            </v-slide-group>
                          </v-col>
                        </v-row>
                      </v-card>-->

                      <!-- <v-card class="my-5">
                      <v-card-title class="headline pa-2">
                        <v-icon class="pr-3" color="indigo" size="28">mdi-clock-fast</v-icon>ประวัติการเข้าเรียน
                      </v-card-title>
                      <v-row class="pa-3">
                        <p class="px-3 my-1">ดาวน์โหลดประวัติการเข้าเรียน</p>
                        <v-spacer></v-spacer>
                        <div class="px-3">
                          <v-chip
                            outlined
                            class="mb-0 white--text"
                            color="teal"
                            @click="$store.state.permission.updateStudent == true ? '' : noPermission()"
                          >
                            <v-avatar left>
                              <v-icon>mdi-file-download-outline</v-icon>
                            </v-avatar>
                            <p class="mb-0">Excel</p>
                          </v-chip>
                        </div>
                      </v-row>
                      <v-row class="px-3">
                        <v-col cols="12">
                          <v-data-table
                            :headers="headersMockup"
                            :items="historyItems"
                            :items-per-page="5"
                            class="elevation-1"
                          ></v-data-table>
                        </v-col>
                      </v-row>
                      </v-card>-->
                    </v-card-text>

                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        elevation="0"
                        class="
                          px-10
                          ma-2
                          subtitle-1
                          text-capitalize
                          font-weight-light
                          button-primary
                        "
                        @click="dialogViewReport = false"
                      >
                        {{ $vuetify.lang.t('$vuetify.courseManagement.close') }}
                      </v-btn>
                    </v-card-actions>
                    <!-- <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        elevation="0"
                        class="px-10 ma-2 subtitle-1 text-capitalize font-weight-light button-primary"
                        @click="dialogViewReport = false"
                      >{{$vuetify.lang.t('$vuetify.courseManagement.close')}}</v-btn>
                    </v-card-actions>
                     <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        class="px-10 ma-2"
                        large
                        dark
                        rounded
                        @click="dialogViewReport = false"
                      >{{$vuetify.lang.t('$vuetify.courseManagement.close')}}</v-btn>
                    </v-card-actions>-->
                  </v-card>
                </v-dialog>

                <v-dialog
                  v-model="dialogExamReport"
                  scrollable
                  persistent
                  max-width="900px"
                >
                  <v-card>
                    <v-toolbar flat dark color="rgb(51, 97, 137)">
                      <v-spacer></v-spacer>
                      <v-toolbar-title
                        class="
                          font-weight-light
                          text-center
                          ml-5
                          text-capitalize
                        "
                        >Report Examination</v-toolbar-title
                      >
                      <v-spacer></v-spacer>
                      <v-btn icon dark @click="closeDialogExamReport">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card-text>
                      <v-col cols="12" class="pb-0 mt-3">
                        <p class="title black--text font-weight-bold">
                          {{ examTitle }}
                        </p>
                      </v-col>
                      <v-col cols="12" class="py-0 d-flex align-center">
                        <p class="subtitle-2 mr-3">Full Score:</p>
                        <p>{{ fullScore }}</p>
                      </v-col>
                      <v-col cols="12" class="py-0 d-flex align-center">
                        <p class="subtitle-2 mr-3">Number of Questions:</p>
                        <p>{{ numOfQuestions }}</p>
                      </v-col>
                      <v-data-table
                        :loading="loading"
                        :headers="headerStudentExam"
                        :page.sync="page_student"
                        :items-per-page="limit_student"
                        @page-count="pageCount_student"
                        hide-default-footer
                        :items="studentReportExams"
                        class="
                          py-5
                          ma-md-5
                          pt-0
                          mt-0font-weight-light
                          custom-table
                        "
                        elevation="3"
                      >
                        <template v-slot:top></template>
                        <template v-slot:item.num="{ item }">
                          <p
                            class="
                              ma-2
                              ml-0
                              md-fixed-width
                              text-left
                              subtitle-2
                              font-weight-light
                            "
                          >
                            {{ item.num }}
                          </p>
                        </template>
                        <template v-slot:item.examDate="{ item }">
                          <p
                            class="
                              ma-2
                              ml-0
                              md-fixed-width
                              subtitle-2
                              font-weight-light
                            "
                          >
                            {{ item.examDate }}
                          </p>
                        </template>
                        <template v-slot:item.score="{ item }">
                          <!-- <v-sheet
                            justify-content="center"
                            class="text-center"
                            align-item="center"
                            height="100%"
                            color="info lighten-1"

                          >-->
                          <div class="backgroud-info">
                            <p
                              class="
                                ma-2
                                ml-0
                                md-fixed-width
                                subtitle-2
                                font-weight-light
                                info--text
                              "
                            >
                              {{ item.score }}
                            </p>
                          </div>
                          <!-- </v-sheet> -->
                        </template>
                        <template v-slot:item.correct="{ item }">
                          <div class="backgroud-success">
                            <p
                              class="
                                ma-2
                                ml-0
                                md-fixed-width
                                subtitle-2
                                font-weight-light
                                success--text
                              "
                            >
                              {{ item.correct }}
                            </p>
                          </div>
                          <!-- <v-sheet
                            justify-content="center"
                            class="text-center"
                            align-item="center"
                            height="100%"
                            color="success lighten-1"
                          >-->

                          <!-- </v-sheet> -->
                        </template>
                        <template v-slot:item.wrong="{ item }">
                          <!-- <v-sheet
                            justify-content="center"
                            class="text-center"
                            align-item="center"
                            height="100%"
                            color="error lighten-1"
                          >-->
                          <div class="backgroud-error">
                            <p
                              class="
                                ma-2
                                ml-0
                                md-fixed-width
                                subtitle-2
                                font-weight-light
                                error--text
                              "
                            >
                              {{ item.wrong }}
                            </p>
                          </div>
                          <!-- </v-sheet> -->
                        </template>
                        <template v-slot:item.noAnswer="{ item }">
                          <!-- <v-sheet
                            justify-content="center"
                            class="text-center"
                            align-item="center"
                            height="100%"
                            color="orange lighten-1"
                          >-->
                          <div class="backgroud-warning">
                            <p
                              class="
                                ma-2
                                ml-0
                                md-fixed-width
                                subtitle-2
                                font-weight-light
                                warning--text
                              "
                            >
                              {{ item.noAnswer }}
                            </p>
                            <!-- </v-sheet> -->
                          </div>
                        </template>
                        <template v-slot:item.action="{ item }">
                          <v-btn
                            elevation="0"
                            class="mb-0 body-2 text-primary text-capitalize"
                            color="white"
                            @click="editScore(item)"
                          >
                            <p class="mb-0">
                              {{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.courseList.edit'
                                )
                              }}
                            </p>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-card-text>
                    <v-card-actions></v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog
                  v-model="dialogEditScoreExam"
                  scrollable
                  persistent
                  max-width="900px"
                >
                  <v-card>
                    <v-toolbar flat dark color="rgb(51, 97, 137)">
                      <v-spacer></v-spacer>
                      <v-toolbar-title
                        class="
                          font-weight-light
                          text-center
                          ml-5
                          text-capitalize
                        "
                        >Edit Score Examination</v-toolbar-title
                      >
                      <v-spacer></v-spacer>
                      <v-btn icon dark @click="closedialogEditScoreExam">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card-text>
                      <div
                        v-for="(qList, index) in arrQuestion"
                        :key="qList._id"
                      >
                        <v-card outlined elevation="0" class="mt-5">
                          <v-toolbar
                            outlined
                            elevation="0"
                            class="py-4"
                            color="grey lighten-4"
                            height="auto"
                            min-height="80"
                          >
                            <v-col cols="9" class="pl-0">
                              <v-toolbar-title class="custom-question">
                                <p class="mb-0">
                                  Question {{ ' ' + (index + 1) }}.
                                  <span
                                    v-html="qList.question"
                                    class="font-weight-bold"
                                  ></span>
                                </p>
                              </v-toolbar-title>
                              <span class="ssubtitle-2 grey--text">
                                (ข้อสอบแบบ{{
                                  question_type[qList.questionType]
                                }})
                              </span>
                            </v-col>

                            <v-col cols="3">
                              <v-row>
                                <v-col class="pl-0 pt-5">คะแนน :</v-col>
                                <v-col class="pa-0">
                                  <v-text-field
                                    class="mt-3"
                                    v-model="qList.studentScore"
                                    :disabled="qList.boolean == false"
                                    single-line
                                    outlined
                                    type="number"
                                    min="0"
                                    background-color="white"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col class="text-right pa-0" cols="12">
                                  <v-btn
                                    v-if="qList.boolean == false"
                                    :disabled="bool == true"
                                    elevation="0"
                                    class="
                                      mb-0
                                      body-2
                                      text-primary text-capitalize
                                    "
                                    color="white"
                                    @click="editScoreExam(qList)"
                                  >
                                    <p class="mb-0">
                                      {{
                                        $vuetify.lang.t(
                                          '$vuetify.courseManagement.courseList.edit'
                                        )
                                      }}
                                    </p>
                                  </v-btn>
                                  <v-btn
                                    v-if="qList.boolean == true"
                                    elevation="0"
                                    class="
                                      mb-0
                                      body-2
                                      text-blue-grey text-capitalize
                                      mr-2
                                    "
                                    color="white"
                                    @click="cancelEditScore(qList)"
                                  >
                                    <p class="mb-0">
                                      {{
                                        $vuetify.lang.t(
                                          '$vuetify.courseManagement.courseList.cancel'
                                        )
                                      }}
                                    </p>
                                  </v-btn>
                                  <v-btn
                                    v-if="qList.boolean == true"
                                    elevation="0"
                                    class="
                                      mb-0
                                      body-2
                                      text-primary text-capitalize
                                      ml-2
                                    "
                                    color="white"
                                    @click="saveEditScore(qList)"
                                  >
                                    <p class="mb-0">
                                      {{
                                        $vuetify.lang.t(
                                          '$vuetify.courseManagement.courseList.save'
                                        )
                                      }}
                                    </p>
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-toolbar>
                          <v-card-text>
                            <p
                              v-if="qList.studentAnswer[0] == ''"
                              class="
                                mb-0
                                error--text
                                font-weight-black
                                display-5
                              "
                            >
                              ไม่ได้ตอบคำถาม
                            </p>
                            <v-list v-show="qList.questionType == 'single'">
                              <v-list-item
                                v-show="
                                  qList.choices[0].text &&
                                  qList.choices[0].text != ''
                                "
                                v-for="(rowChoiceText, index) in qList.choices"
                                :key="rowChoiceText._id + '_quiz_tab'"
                              >
                                <v-list-item-icon class="custom-icon">
                                  <v-icon
                                    v-show="
                                      qList.studentAnswer[0] ==
                                      rowChoiceText._id
                                    "
                                    :color="
                                      getstudentCorrectAnser(
                                        qList.studentAnswer[0],
                                        qList.correctAnswer[0]
                                      ) == rowChoiceText._id
                                        ? 'success'
                                        : 'error'
                                    "
                                  >
                                    {{
                                      getstudentCorrectAnser(
                                        qList.studentAnswer[0],
                                        qList.correctAnswer[0]
                                      ) == rowChoiceText._id
                                        ? 'mdi-check'
                                        : 'mdi-close'
                                    }}
                                  </v-icon>
                                  <v-icon
                                    v-show="
                                      qList.correctAnswer[0] ==
                                        rowChoiceText._id &&
                                      qList.studentAnswer[0] !=
                                        rowChoiceText._id
                                    "
                                    color="success"
                                  >
                                    {{
                                      qList.correctAnswer[0] ==
                                      rowChoiceText._id
                                        ? 'mdi-check'
                                        : 'mdi-close'
                                    }}
                                  </v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                  <div class="d-flex ml-md-5">
                                    <div class="custom-number-panel">
                                      <div
                                        class="number-border"
                                        :class="
                                          qList.studentAnswer[0] ==
                                            rowChoiceText._id ||
                                          qList.studentAnswer == null
                                            ? 'have-number-border'
                                            : ''
                                        "
                                      >
                                        <div class="number">
                                          {{ index + 1 }}
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      class="
                                        pa-5
                                        mr-5
                                        have-border
                                        ml-10
                                        full-width
                                      "
                                    >
                                      <p
                                        class="mb-0"
                                        v-html="rowChoiceText.text"
                                      ></p>
                                    </div>
                                  </div>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                            <div v-show="qList.questionType == 'fillgaptext'">
                              <div
                                class="mb-5"
                                v-for="(
                                  answerText, index
                                ) in qList.studentAnswerText"
                                :key="index"
                              >
                                <p class="font-weight-bold">
                                  คำตอบ
                                  <span
                                    v-show="qList.studentAnswerText.length > 1"
                                    >ที่ &nbsp; {{ index + 1 }}</span
                                  >
                                </p>
                                <div class="have-border mt-3 pa-5">
                                  <p class="mb-0" v-html="answerText"></p>
                                </div>
                              </div>

                              <p class="font-weight-bold">เฉลย</p>
                              <div class="have-border mt-3 pa-5">
                                <div
                                  v-for="(
                                    correctText, index
                                  ) in qList.correctText"
                                  :key="index"
                                >
                                  <p v-html="correctText"></p>
                                  <v-divider
                                    v-show="
                                      qList.correctText.length > 1 &&
                                      index !== qList.correctText.length - 1
                                    "
                                  ></v-divider>
                                </div>
                              </div>
                              <div></div>
                            </div>
                            <div v-show="qList.questionType == 'matchsome'">
                              <div class="py-5 full-width">
                                <div
                                  v-for="(
                                    questionMatch, index
                                  ) in qList.questionMatch"
                                  :key="index"
                                >
                                  <div
                                    class="
                                      d-flex
                                      flex-no-wrap
                                      justify-space-between
                                    "
                                  >
                                    <div>
                                      <div class="mb-1">
                                        <p class="font-weight-bold">
                                          หัวข้อ &nbsp; {{ index + 1 }}
                                        </p>
                                        <p
                                          class="mb-0"
                                          v-html="questionMatch"
                                        ></p>
                                      </div>

                                      <p class="font-weight-bold">จับคู่กับ</p>
                                      <p
                                        v-if="
                                          qList.studentAnswerMatch[index]
                                            .correct == ''
                                        "
                                        class="
                                          mb-0
                                          error--text
                                          font-weight-black
                                          display-5
                                        "
                                      >
                                        ไม่ได้ตอบคำถาม
                                      </p>
                                      <div
                                        v-for="coices in qList.choices"
                                        :key="coices._id"
                                      >
                                        <p
                                          v-show="
                                            qList.studentAnswerMatch[index]
                                              .correct != '' &&
                                            qList.studentAnswerMatch[index]
                                              .correct == coices._id
                                          "
                                          v-html="coices.text"
                                        ></p>
                                      </div>
                                    </div>

                                    <div>
                                      <v-btn
                                        class="ma-2"
                                        @click="
                                          showAnswer(
                                            qList.correctMatch[index],
                                            qList.choices
                                          )
                                        "
                                        outlined
                                        color="success"
                                        >ดูเฉลย</v-btn
                                      >
                                    </div>
                                  </div>
                                  <v-divider
                                    class="my-5"
                                    v-show="
                                      index !== qList.questionMatch.length - 1
                                    "
                                  ></v-divider>
                                </div>
                              </div>

                              <!--<v-list>
                                                            <v-list-item v-for="(questionMatch,index) in qList.questionMatch" :key="index">
                                                                <v-list-item-content>
                                                                    <div class="d-flex ml-md-5">
                                                                        <div class="custom-number-panel">
                                                                            <div class="number-border">
                                                                                <div class="number">{{index+1}}</div>
                                                                            </div>
                                                                        </div>

                                                                       
                                                                    </div>
                                                                </v-list-item-content>
                                                            </v-list-item>
                              </v-list>-->
                            </div>
                            <div v-show="qList.questionType == 'multiple'">
                              <v-list>
                                <v-list-item
                                  v-show="
                                    qList.choices[0].text &&
                                    qList.choices[0].text != ''
                                  "
                                  v-for="(
                                    rowChoiceText, index_choice
                                  ) in qList.choices"
                                  :key="rowChoiceText._id + '_quiz_tab'"
                                >
                                  <v-list-item-icon class="custom-icon">
                                    <div
                                      v-for="(
                                        studentAnswer, index
                                      ) in qList.studentAnswer"
                                      :key="index"
                                    >
                                      <!--<p>{{studentAnswer}}</p>-->
                                      <v-icon
                                        v-show="
                                          studentAnswer == rowChoiceText._id
                                        "
                                        :color="
                                          getCorrectAnser(
                                            studentAnswer,
                                            qList.correctAnswer
                                          ) == rowChoiceText._id
                                            ? 'success'
                                            : 'error'
                                        "
                                      >
                                        {{
                                          getCorrectAnser(
                                            studentAnswer,
                                            qList.correctAnswer
                                          ) == rowChoiceText._id
                                            ? 'mdi-check'
                                            : 'mdi-close'
                                        }}
                                      </v-icon>
                                      <v-icon
                                        v-show="
                                          chekCorrectAnser(
                                            rowChoiceText._id,
                                            qList.correctAnswer
                                          ) &&
                                          studentAnswer != rowChoiceText._id
                                        "
                                        color="success"
                                      >
                                        {{
                                          chekCorrectAnser(
                                            rowChoiceText._id,
                                            qList.correctAnswer
                                          )
                                            ? 'mdi-check'
                                            : 'mdi-close'
                                        }}
                                      </v-icon>
                                      <!-- <v-icon v-show="studentAnswer != rowChoiceText._id " color="error">{{chekCorrectAnser(rowChoiceText._id,qList.correctAnswer)?'mdi-check':'mdi-close'}}</v-icon>-->
                                    </div>
                                  </v-list-item-icon>

                                  <v-list-item-content>
                                    <div class="d-flex ml-md-5">
                                      <div
                                        class="custom-number-panel"
                                        v-for="(
                                          studentAnswer, index
                                        ) in qList.studentAnswer"
                                        :key="index"
                                      >
                                        <div
                                          class="number-border"
                                          :class="
                                            studentAnswer == rowChoiceText._id
                                              ? 'have-number-border'
                                              : ''
                                          "
                                        >
                                          <div class="number">
                                            {{ index_choice + 1 }}
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        class="
                                          pa-5
                                          mr-5
                                          have-border
                                          ml-10
                                          full-width
                                        "
                                      >
                                        <p
                                          class="mb-0"
                                          v-html="rowChoiceText.text"
                                        ></p>
                                      </div>
                                    </div>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>
                            </div>

                            <!--<v-row>
                                <v-col lg="6" md="6" sm="6" cols="12" v-show="(qList.choices[0].text && qList.choices[0].text != '')" v-for="rowChoiceText in qList.choices" :key="rowChoiceText._id+'_quiz_tab'">
                                    <v-card :class="qList.studentAnswer[0] == rowChoiceText._id ? 'choice py-4 px-9 correct' : 'choice py-4 px-9 incorrect'" elevation="0" outlined>
                                        <div v-if="qList.correctAnswer[0] == rowChoiceText._id" class="check">
                                            <v-icon>mdi-check</v-icon>
                                        </div>
                                        <p class="mb-0" v-html="rowChoiceText.text"></p>
                                    </v-card>
                                </v-col>
                                <v-col lg="3" md="3" sm="3" cols="12" v-show="(qList.choices[0].image && qList.choices[0].image != '')" v-for="rowChoiceImg in qList.choices" :key="rowChoiceImg._id+'_quiz_tab'">
                                    <v-card :class="qList.studentAnswer[0] == qList.correctAnswer[0] == rowChoiceImg._id ? 'choice py-4 px-9 correct' : 'choice py-4 px-9'" elevation="0" outlined>
                                        <div v-if="qList.correctAnswer[0] == rowChoiceImg._id" class="check">
                                            <v-icon>mdi-check</v-icon>
                                        </div>
                                        <v-img :src="rowChoiceImg.image" :lazy-src="rowChoiceImg.image" aspect-ratio="1" class="grey lighten-2"></v-img>
                                    </v-card>
                                </v-col>
                            </v-row>-->
                          </v-card-text>
                        </v-card>
                      </div>
                      <div class="text-center">
                        <v-pagination
                          v-model="page_editScore"
                          :length="pageCount_editScore"
                          @input="changePageEditScore()"
                          color="rgb(66, 154, 216)"
                        ></v-pagination>
                      </div>
                    </v-card-text>
                    <!-- <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        elevation="0"
                        class="px-10 ma-2 subtitle-1 text-capitalize font-weight-light button-primary"
                        @click="saveEditScore()"
                      >Save</v-btn>
                    </v-card-actions>-->
                  </v-card>
                </v-dialog>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogRecycleBin"
          scrollable
          persistent
          width="950px"
        >
          <v-card>
            <v-toolbar flat dark color="rgb(51, 97, 137)">
              <v-toolbar-title>
                <v-icon left>mdi-delete-outline</v-icon
                >{{
                  $vuetify.lang.t('$vuetify.courseManagement.filterBar.bin')
                }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn icon dark @click="closeDialogRecycleBin" v-on="on">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span class="subtitle-1">{{
                  $vuetify.lang.t('$vuetify.courseManagement.close')
                }}</span>
              </v-tooltip>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-card-actions
                    v-if="selectCoursesBin.length !== 0"
                    class="bg-sheet"
                  >
                    <!-- <v-checkbox
                      class="my-2"
                      hide-details
                      v-model="allSelected"
                      @change="selectAll"
                    ></v-checkbox> -->
                    <p v-show="selectCoursesBin.length !== 0" class="pl-3 mb-0">
                      Selected
                    </p>
                    <v-row
                      align="center"
                      justify="end"
                      style="margin-right: 10px !important"
                    >
                      <v-btn
                        v-show="selectCoursesBin.length !== 0"
                        elevation="0"
                        class="mb-0 body-2 text-capitalize"
                        color="white"
                        @click="cancelSelectBin()"
                      >
                        <p class="mb-0">Cancel</p>
                      </v-btn>
                      <v-divider inset vertical class="mb-2 mx-1"></v-divider>
                      <v-btn
                        v-show="selectCoursesBin.length !== 0"
                        elevation="0"
                        class="mb-0 body-2 text-primary text-capitalize"
                        color="white"
                        @click="confirmMultiRecover(null)"
                      >
                        <p class="mb-0">Recover</p>
                      </v-btn>
                    </v-row>
                  </v-card-actions>
                  <v-data-table
                    :headers="headersBin"
                    hide-default-footer
                    :items="coursesBin"
                    show-select
                    v-model="selectCoursesBin"
                    class="page-card font-weight-light"
                    elevation="3"
                  >
                    <template v-slot:item.image="{ item }">
                      <!-- <a @click="editItem(item)"> -->
                      <v-img
                        :src="item.image"
                        class="my-2 rounded-card"
                        width="120"
                        aspect-ratio="1.7"
                      >
                        <template v-slot:placeholder>
                          <v-row class="ma-0" align="center" justify="center">
                            <v-icon
                              v-if="!item.image"
                              class="mx-auto"
                              elevation="3"
                              size="70"
                              >mdi-image-outline</v-icon
                            >
                          </v-row>
                        </template>
                      </v-img>
                      <!-- </a> -->
                    </template>
                    <template v-slot:item.title="{ item }">
                      <!-- <a @click="editItem(item)"> -->
                      <p
                        class="
                          ma-2
                          md-fixed-width
                          body-2
                          font-weight-light
                          text-left
                        "
                      >
                        {{ item.title }}
                      </p>
                      <!-- </a> -->
                    </template>
                    <template v-slot:item.teacher="{ item }">
                      <div
                        v-for="teacher in item.teacher"
                        :key="teacher._id._id"
                      >
                        <p class="ma-2 xs-fixed-width body-2 font-weight-light">
                          {{ teacher._id.displayName }}
                        </p>
                      </div>
                    </template>
                    <template v-slot:item.category="{ item }">
                      <div
                        v-for="category in item.category"
                        :key="category._id"
                      >
                        <p class="mb-0 body-2 font-weight-light">
                          {{ category.title }}
                        </p>
                      </div>
                    </template>

                    <!-- <template v-slot:item.active="{ item }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <div v-on="on">
                            <v-switch
                              color="rgb(66, 154, 216)"
                              inset
                              v-model="item.active"
                              @click="
                                $store.state.permission.activeCourse == true
                                  ? openModalStatus(item)
                                  : noPermission()
                              "
                            ></v-switch>
                          </div>
                        </template>
                        <span v-if="item.active">
                          {{
                            $vuetify.lang.t(
                              "$vuetify.courseManagement.courseList.clickToSuspend"
                            )
                          }}
                        </span>
                        <span v-else>
                          {{
                            $vuetify.lang.t(
                              "$vuetify.courseManagement.courseList.clickToActivate"
                            )
                          }}
                        </span>
                      </v-tooltip>
                    </template> -->
                    <template v-slot:item.edit="{ item }">
                      <div class="d-flex justify-center">
                        <!-- <v-btn
                          elevation="0"
                          class="mb-0 body-2 text-primary text-capitalize"
                          color="white"
                          @click="viewReport(item)"
                          >{{
                            $vuetify.lang.t(
                              "$vuetify.courseManagement.courseList.viewReport"
                            )
                          }}</v-btn
                        >
                        <v-divider inset vertical class="mb-2 mx-1"></v-divider> -->
                        <v-btn
                          elevation="0"
                          class="mb-0 body-2 text-primary text-capitalize"
                          color="white"
                          @click="confirmRecover(item)"
                        >
                          <p class="mb-0">Recover</p>
                        </v-btn>
                      </div>
                    </template>
                  </v-data-table>
                  <div class="pt-3 pr-3 pb-5 text-center">
                    <v-pagination
                      v-model="paramsBin.page"
                      :length="pageCountBin"
                      @input="changePageBin"
                      color="rgb(66, 154, 216)"
                    ></v-pagination>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogStatus" persistent max-width="450">
          <v-card>
            <v-card-title class="headline">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.courseList.confirmUnpublish'
                )
              }}
            </v-card-title>
            <v-card-text>
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.courseList.unpublishDescript'
                )
              }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="0"
                class="px-7 ma-2 subtitle-2 font-weight-light"
                color="grey darken-1"
                outlined
                @click="closeDialogActive()"
                >{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn
              >
              <v-btn
                elevation="0"
                class="px-7 ma-2 subtitle-2 font-weight-light"
                dark
                color="error darken-1"
                @click="userUpdateActive()"
                >{{ $vuetify.lang.t('$vuetify.confirm') }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogStatusActive" persistent max-width="450">
          <v-card>
            <v-card-title class="headline">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.courseList.confirmPublish'
                )
              }}
            </v-card-title>
            <v-card-text>
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.courseList.publishDescript'
                )
              }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="0"
                class="px-7 ma-2 subtitle-2 font-weight-light"
                color="grey darken-1"
                outlined
                @click="closeDialogActive()"
                >{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn
              >
              <v-btn
                elevation="0"
                class="px-7 ma-2 subtitle-2 button-primary font-weight-light"
                dark
                @click="userUpdateActive()"
                >{{ $vuetify.lang.t('$vuetify.confirm') }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogCantPublic" persistent max-width="450">
          <v-card>
            <v-card-title class="headline">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.courseList.failedToSave'
                )
              }}
            </v-card-title>
            <v-card-text>{{ messageCantPublic }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <!-- <v-btn color="grey darken-1" dark rounded outlined @click="dialogCantPublic = false">ยกเลิก</v-btn> -->
              <v-btn
                elevation="0"
                class="px-7 ma-2 subtitle-2 font-weight-light"
                dark
                color="error darken-1"
                @click="dialogCantPublic = false"
                >{{ $vuetify.lang.t('$vuetify.confirm') }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogSuccess" max-width="450">
          <v-card>
            <v-card-title class="headline">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.courseList.successfullySave'
                )
              }}
            </v-card-title>

            <v-card-text>
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.courseList.canModifyLater'
                )
              }}
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="green darken-1" text @click="dialogSuccess = false">
                {{
                  $vuetify.lang.t('$vuetify.courseManagement.courseList.done')
                }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <div class="pt-3 pr-3 pb-5 text-center">
        <v-pagination
          v-model="params.page"
          :length="pageCount"
          @input="changePage"
          color="rgb(66, 154, 216)"
          :total-visible="10"
        ></v-pagination>
      </div>

      <!-- show answer dialog-->
      <v-dialog v-model="correct_dialog" max-width="900px">
        <v-card>
          <v-toolbar flat dark color="rgb(51, 97, 137)">
            <v-spacer></v-spacer>
            <v-toolbar-title
              class="font-weight-light text-center ml-5 text-capitalize"
              >เฉลย</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn icon dark @click="correct_dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-5">
            <p v-html="correct_matchsome.text"></p>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogMultiDelete" persistent max-width="450">
        <v-card>
          <v-card-title class="headline"
            >คุณต้องการย้ายคอร์สที่เลือกไปยังถังขยะใช่หรือไม่</v-card-title
          >
          <v-card-text>
            <p>
              เมื่อย้ายไปยังถังขยะแล้ว คุณสามารถนำคอร์สกลับมาได้อีกในภายหลัง
            </p>
          </v-card-text>
          <v-card-text>
            <p class="font-weight-bold">
              <strong class="red--text">คำเตือน!</strong>
              หลังจากย้ายคอร์สไปยังถังขยะแล้ว คอร์สจะถูกหยุดเผยแพร่โดยอัตโนมัติ
            </p></v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              elevation="0"
              class="px-7 ma-2 subtitle-2 font-weight-light text-capitalize"
              color="grey darken-1"
              outlined
              :disabled="this.loadingDelete == true"
              @click="dialogMultiDelete = false"
              >ยกเลิก</v-btn
            >
            <v-btn
              elevation="0"
              class="px-7 ma-2 subtitle-2 font-weight-light"
              color="error darken-1"
              :disabled="this.loadingDelete == true"
              @click="deleteMultiCourse()"
              ><p v-if="loadingDelete == false" class="pa-0 ma-0">ยืนยัน</p>
              <p v-if="loadingDelete == true" class="pa-0 ma-0">
                กำลังย้าย
              </p></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogMultiDeleteSuccess" max-width="450">
        <v-card>
          <v-card-title class="headline">ย้ายคอร์สเรียบร้อย</v-card-title>

          <v-card-text>คอร์สถูกย้ายไปยังถังขยะเรียบร้อยแล้ว</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="green darken-1"
              text
              @click="dialogMultiDeleteSuccess = false"
              >เสร็จสิ้น</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogDelete" persistent max-width="450">
        <v-card>
          <v-card-title class="headline"
            >คุณต้องการย้ายคอร์สไปยังถังขยะใช่หรือไม่</v-card-title
          >
          <v-card-text>
            <p>
              เมื่อย้ายไปยังถังขยะแล้ว คุณสามารถนำคอร์สกลับมาได้อีกในภายหลัง
            </p>
          </v-card-text>
          <v-card-text v-if="actionCourses.active == true">
            <p class="font-weight-bold">
              <strong class="red--text">คำเตือน!</strong>
              หลังจากย้ายคอร์สไปยังถังขยะแล้ว คอร์สจะถูกหยุดเผยแพร่โดยอัตโนมัติ
            </p></v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              elevation="0"
              class="px-7 ma-2 subtitle-2 font-weight-light text-capitalize"
              color="grey darken-1"
              outlined
              :disabled="this.loadingDelete == true"
              @click="dialogDelete = false"
              >ยกเลิก</v-btn
            >
            <v-btn
              elevation="0"
              class="px-7 ma-2 subtitle-2 font-weight-light"
              color="error darken-1"
              :disabled="this.loadingDelete == true"
              @click="deleteCourse()"
              ><p v-if="loadingDelete == false" class="pa-0 ma-0">ยืนยัน</p>
              <p v-if="loadingDelete == true" class="pa-0 ma-0">
                กำลังย้าย
              </p></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogRecover" persistent max-width="450">
        <v-card>
          <v-card-title class="headline"
            >คุณต้องการกู้คืนคอร์สที่เลือกออกจากถังขยะใช่หรือไม่</v-card-title
          >
          <v-card-text>
            <p>
              เมื่อกู้คืนคอร์สออกจากถังขยะแล้ว จะสามารถแก้ไขข้อมูลคอร์สได้ทันที
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              elevation="0"
              class="
                px-9
                ma-2
                subtitle-2
                button-secondary
                font-weight-light
                text-capitalize
              "
              outlined
              :disabled="this.loadingRecover == true"
              @click="dialogRecover = false"
              >ยกเลิก</v-btn
            >
            <v-btn
              class="
                px-10
                ma-2
                subtitle-2
                text-capitalize
                font-weight-light
                button-primary
              "
              :disabled="this.loadingRecover == true"
              @click="recoverCourse()"
              ><p v-if="loadingRecover == false" class="pa-0 ma-0">ยืนยัน</p>
              <p v-if="loadingRecover == true" class="pa-0 ma-0">
                กำลังย้าย
              </p></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogMultiRecover" persistent max-width="450">
        <v-card>
          <v-card-title class="headline"
            >คุณต้องการกู้คืนคอร์สที่เลือกออกจากถังขยะใช่หรือไม่</v-card-title
          >
          <v-card-text>
            <p>
              เมื่อกู้คืนคอร์สออกจากถังขยะแล้ว จะสามารถแก้ไขข้อมูลคอร์สได้ทันที
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              elevation="0"
              class="
                px-9
                ma-2
                subtitle-2
                button-secondary
                font-weight-light
                text-capitalize
              "
              outlined
              :disabled="this.loadingRecover == true"
              @click="dialogMultiRecover = false"
              >ยกเลิก</v-btn
            >
            <v-btn
              class="
                px-10
                ma-2
                subtitle-2
                text-capitalize
                font-weight-light
                button-primary
              "
              :disabled="this.loadingRecover == true"
              @click="recoverMultiCourse()"
              ><p v-if="loadingRecover == false" class="pa-0 ma-0">ยืนยัน</p>
              <p v-if="loadingRecover == true" class="pa-0 ma-0">
                กำลังย้าย
              </p></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogMultiRecoverSuccess" max-width="450">
        <v-card>
          <v-card-title class="headline">กู้คืนคอร์สเรียบร้อย</v-card-title>

          <v-card-text>คอร์สถูกย้ายไปยังรายการคอร์สเรียบร้อยแล้ว</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" text @click="closeDialogRecover"
              >เสร็จสิ้น</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { getUserList, getUserGroup } from '@/service/account/manageUser';
import {
  getCourse,
  getReportCourse,
  getReportStudentInCourse,
  getReportStudentHistory,
  updateActive,
  getCourseById,
  getReportExamScore,
  getListQuestionExam,
  editScore,
  moveCourseToBin,
  getCourseListBin,
} from '@/service/course/course';
import { uploadImage } from '@/service/upload/upload';
import { getUserEditByID } from '@/service/account/manageUser';
import { loadCategory } from '@/service/category/category';
import { loadTagList } from '@/service/tag';
import { loadSkillList } from '@/service/skill/skill';
import ImportUserDialog from '@/views/course/users.vue';
import confirmTutorDialog from '@/views/user/confirmTutor.vue';
import { getLive } from '@/service/course/live';
import { getRoom } from '@/service/room/room';
// import JsonExcel from "vue-json-excel";
import VueApexCharts from 'vue-apexcharts';
import { getOverviewReportCourse } from '@/service/course/report';

// import * as firebase from "firebase";
// var config = {
//   apiKey: "AIzaSyCvQEwP5Kp5iBb78AvdjwHe5wfG2ruOvbA",
//   authDomain: "deknerd-556e6.firebaseapp.com",
//   databaseURL: "https://deknerd-556e6.firebaseio.com",
//   projectId: "deknerd-556e6",
//   storageBucket: "deknerd-556e6.appspot.com",
//   messagingSenderId: "434518633712",
//   appId: "1:434518633712:web:d564d8f1be8efe1014a635",
// };
// firebase.initializeApp(config);
import firebase from '@/service/firebase';
var database = firebase.database();

export default {
  components: {
    ImportUserDialog,
    // JsonExcel,
    confirmTutorDialog,
    apexchart: VueApexCharts,
  },
  data: function () {
    return {
      autoselectMenu: false,
      teachers: [],
      dialogFullReport: false,
      dialogViewReport: false,
      dialogExamReport: false,
      dialogFormUser: false,
      dialogStatus: false,
      dialogStatusActive: false,
      dialogSuccess: false,
      dialogDelete: false,
      dialogMultiDelete: false,
      dialogMultiRecover: false,
      dialogMultiDeleteSuccess: false,
      dialogMultiRecoverSuccess: false,
      loadingDelete: false,
      loadingRecover: false,
      dialogRecycleBin: false,
      dialogRecover: false,

      pageCountBin: 0,

      title: '',
      isEdit: false,
      image: null,
      imageReady: false,
      imgPreview: null,
      imageCourse: null,
      searchCourseReport: null,
      searchStudentReport: null,
      courseId: '',
      studentId: '',
      roomId: '',
      fullName: '',
      room: '',
      firstName: '',
      lastName: '',
      email: '',
      username: '',
      tel: '',
      birthdate: '',
      gender: '',
      reportStudentList: [],
      historyList: [],
      historyExamList: [],
      students: [],
      chooseRoom: false,
      objCourse: [],
      knowledge: 0,
      // roomTitle: "",
      instructorName: '',
      selectedRoom: '',
      roomsCourse: [],
      status_student_toggle: 0,
      status_toggle: 0,
      countStartedStudents: [],
      countNotStartedStudents: [],
      examTitle: '',
      fullScore: 0,
      numOfQuestions: 0,
      studentReportExams: [],
      dialogEditScoreExam: false,
      arrQuestion: [],
      bool: false,

      alert: false,
      chooseSection: false,
      filterdialog: false,
      deleteDialog: false,

      userDialog: false,
      confirmDialog: false,
      registerTutoralert: false,

      loading: true,
      searchby: this.$vuetify.lang.t('$vuetify.courseManagement.courseName'),
      searchType: [
        this.$vuetify.lang.t('$vuetify.courseManagement.courseName'),
        this.$vuetify.lang.t('$vuetify.courseManagement.teacherName'),
      ],

      statusExamOfOneLenghtLecture: false,
      checkLenghtLectureEachSection: false,

      //usergroup
      groupUsers: [],
      arrayGroup: [],
      userGroupSearch: [],
      userSort: [],
      userGroupSearch2: [],
      userGroupAllAtIndex: [],

      // series: [
      //   {
      //     name: "ข้อที่ถูก",
      //     data: [44, 55, 57, 56, 61,],
      //   },
      //   {
      //     name: "ข้อที่ถูก",
      //     data: [44, 55, 57, 56, 61,],
      //   },
      //   {
      //     name: "คะแนนของคุณ",
      //     data: [76, 85, 100, 98, 87]
      //   }
      // ],
      // chartOptions: {
      //   chart: {
      //     type: "bar"
      //   },
      //   plotOptions: {
      //     bar: {
      //       horizontal: false,
      //       columnWidth: "50%"
      //     }
      //   },
      //   dataLabels: {
      //     enabled: false
      //   },
      //   stroke: {
      //     show: true,
      //     width: 2,
      //     colors: ["transparent"]
      //   },
      //   grid: {
      //     row: {
      //       colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
      //       opacity: 0.5
      //     }
      //   },
      //   xaxis: {
      //     categories: [
      //       "ครั้งที่ 1",
      //       "ครั้งที่ 2",
      //       "ครั้งที่ 3",
      //       "ครั้งที่ 4",
      //       "ครั้งที่ 5"
      //     ]
      //   },
      //   // yaxis: {
      //   //   subtitle: {
      //   //     text: "คะแนน"
      //   //   }
      //   // },
      //   fill: {
      //     opacity: 1
      //   },
      //   tooltip: {
      //     y: {
      //       formatter: function(val) {
      //         return val + " คะแนน";
      //       }
      //     }
      //   }
      // },

      fileExcelName: 'รายงานสรุปผลการสอบ.xls',
      dataForExcel: [],
      // dataForExcel: [
      //   { รายการสอบ: "Another", },
      //   { รายการสอบ: "Another", ครั้งที่1: "Regular cell" },
      //   { รายการสอบ: "Hello", ครั้งที่1: "World", ครั้งที่2: "World" },
      // ],

      // {
      //     text: this.$vuetify.lang.t(
      //       "$vuetify.courseManagement.courseList.studentManagement"
      //     ),
      //     align: "center",
      //     sortable: false,
      //     value: "actions"
      //   },
      //   {
      //     text: this.$vuetify.lang.t(
      //       "$vuetify.courseManagement.courseList.report"
      //     ),
      //     align: "center",
      //     sortable: false,
      //     value: "report"
      //   },
      headerStudentExam: [
        {
          text: 'No',
          align: 'center',
          sortable: false,
          value: 'num',
          width: '5%',
        },
        {
          text: 'Exam Date',
          align: 'center',
          sortable: false,
          value: 'examDate',
          width: '50%',
        },
        {
          text: 'Score',
          align: 'center',
          sortable: false,
          value: 'score',
          width: '15%',
        },
        {
          text: 'Correct',
          align: 'center',
          sortable: false,
          value: 'correct',
          width: '10%',
        },
        {
          text: 'Wrong',
          align: 'center',
          sortable: false,
          value: 'wrong',
          width: '10%',
        },
        {
          text: 'No Answer',
          align: 'center',
          sortable: false,
          value: 'noAnswer',
          width: '10%',
        },
        {
          text: 'Action',
          align: 'center',
          sortable: false,
          value: 'action',
          width: '10%',
        },
      ],
      headerStudents: [
        {
          text: this.$vuetify.lang.t('$vuetify.profilePic'),
          align: 'center',
          sortable: false,
          value: 'image',
          width: '15%',
        },
        {
          text: this.$vuetify.lang.t('$vuetify.fullName'),
          value: 'fullName',
          align: 'start',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t('$vuetify.progress'),
          value: 'progress',
          align: 'start',
          sortable: false,
          width: '40%',
        },
        // {
        //   text: this.$vuetify.lang.t("$vuetify.email"),
        //   value: "email",
        //   align: "center",
        //   sortable: false
        // },
        // {
        //   text: this.$vuetify.lang.t("$vuetify.username"),
        //   value: "userName",
        //   align: "center",
        //   sortable: false
        // },
        // {
        //   text: this.$vuetify.lang.t("$vuetify.room"),
        //   value: "room",
        //   align: "center",
        //   sortable: false
        // },
        {
          text: '',
          value: 'report',
          align: 'center',
          sortable: false,
          width: '10%',
        },
        // {
        //   text: this.$vuetify.lang.t("$vuetify.studentInformation"),
        //   value: "actions",
        //   align: "center",
        //   sortable: false
        // }
      ],
      headersMockup: [
        {
          text: 'วันที่',
          align: 'center',
          sortable: false,
          value: 'date',
        },
        {
          text: 'เวลาที่ใช้งาน',
          align: 'center',
          value: 'timeLearn',
          sortable: false,
        },
        {
          text: 'กิจกรรม',
          align: 'center',
          value: 'activity',
          sortable: false,
        },
      ],
      historyItems: [
        {
          date: '4 เมษายน 2563',
          timeLearn: '03:00:00 ชม.',
          activity: 'ดาราศาสตร์',
        },
        {
          date: '10 เมษายน 2563',
          timeLearn: '03:00:00',
          activity: 'วิทยาศาสตร์ ชม.',
        },
      ],
      disabledCount: 0,
      courses: [],
      coursesBin: [],
      selectCourses: [],
      actionCourses: [],

      selectCoursesBin: [],
      actionCoursesBin: [],
      searchdata: '',
      sortData: 'เวลา สูง-ต่ำ',
      searchCourse: null,
      pageCount: 1,
      limit: 10,
      searchStudent: null,
      category: [],
      skill: [],
      selectedSkill: [],
      selectedSkills: [],
      selectedTag: [],
      selectedCategory: null,
      active: null,
      params: {},
      deleteItemID: [],

      searchSkill: null,
      oldLengthSkill: 0,
      newLengthSkill: 0,

      //user
      manageUserCourseID: '',

      //select dialog
      selectSectionDialog: false,
      section_headers: [
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.dialogChooseStudyingGroup.groupName'
          ),
          align: 'start',
          sortable: false,
          value: 'title',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.dialogChooseStudyingGroup.lecturerName'
          ),
          value: 'teacher',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.dialogChooseStudyingGroup.numberStudents'
          ),
          value: 'countStudent',
          sortable: false,
          align: 'center',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.dialogChooseStudyingGroup.chooseGroup'
          ),
          sortable: false,
          align: 'center',
          value: 'select',
        },
      ],
      // id: room._id,
      //teacher: room.teacher,
      //title: room.title,
      //countStudent: room.countStudent,
      //isPublic: room.isPublic,
      //permissionedit: room.permissionedit
      section_data: [],
      roomID: '',
      searchdataStudent: '',

      isTeacher: '',
      reject_note: '',
      rooms: [],
      dialogCantPublic: false,
      messageCantPublic: '',

      // paginaton report student
      page_student: 1,
      limit_student: 50,
      pageCount_student: 1,
      tempScore: null,

      page_editScore: 1,
      limit_editScore: 50,
      pageCount_editScore: 1,

      // filter student panel
      panel: [0, 1],
      exam_select: ['John'],
      range: [0, 70],
      min: 0,
      max: 100,
      valid: true,

      completedUser: 0,
      notCompletedUser: 0,
      totalUser: 0,
      userToday: 0,
      onlineUser: 0,
      onlineUserRef: 0,
      totalPercent: 0,
      sumPercentProgress: 0,
      differencePercent: 0,

      //question type matchsome
      correct_dialog: false,
      correct_matchsome: [],
      question_type: {
        single: 'ตัวเลือกเดียว',
        fillgaptext: 'เติมคำ',
        matchsome: 'จับคู่',
        multiple: 'หลายตัวเลือก',
      },

      // more item
      more_item: [{}],
      // series: [],
      // chartOptions: {
      //   series: this.series,
      //   chart: {
      //     width: 100,
      //     type: "donut",
      //   },
      //   dataLabels: {
      //     enabled: true,
      //   },
      //   title: {
      //     display: true,
      //     text: "Learning Progress",
      //   },
      //   labels: ["Completed", "Not Completed"],
      //   fill: {
      //     type: "gradient",
      //     colors: ["#0779e4", "#699ab2"],
      //   },
      //   colors: ["#0779e4", "#699ab2"],
      //   legend: {
      //     formatter: function (val, opts) {
      //       return (
      //         val +
      //         " " +
      //         opts.w.globals.series[opts.seriesIndex].toFixed(2) +
      //         "%"
      //       );
      //     },
      //     markers: {
      //       fillColors: ["#0779e4", "#699ab2"],
      //     },
      //     offsetY: 0,
      //     height: 50,
      //   },
      //   responsive: [
      //     {
      //       breakpoint: 480,
      //       options: {
      //         chart: {
      //           width: 200,
      //         },
      //         legend: {
      //           position: "bottom",
      //         },
      //       },
      //     },
      //   ],
      // },
      // seriesLearningProgress: [],
      // chartOptionsLearningProgress: {
      //   series: this.seriesLearningProgress,
      //   chart: {
      //     width: 100,
      //     type: "donut",
      //   },
      //   dataLabels: {
      //     enabled: true,
      //   },
      //   title: {
      //     display: true,
      //     text: "About Learners",
      //   },
      //   labels: ["Completed", "Not Completed"],
      //   fill: {
      //     type: "gradient",
      //     colors: ["#0779e4", "#ec0101"],
      //   },
      //   colors: ["#0779e4", "#ec0101"],
      //   legend: {
      //     formatter: function (val, opts) {
      //       return val + " " + opts.w.globals.series[opts.seriesIndex];
      //     },
      //     markers: {
      //       fillColors: ["#0779e4", "#ec0101"],
      //     },
      //     offsetY: 0,
      //     height: 50,
      //   },
      //   responsive: [
      //     {
      //       breakpoint: 480,
      //       options: {
      //         chart: {
      //           width: 200,
      //         },
      //         legend: {
      //           position: "bottom",
      //         },
      //       },
      //     },
      //   ],
      // },
      userName: '',
      seriesAngleCircle: [],
      chartOptionsAngleCircle: {
        chart: {
          height: 400,
          type: 'radialBar',
        },
        plotOptions: {
          radialBar: {
            hollow: {
              margin: 0,
              size: '70%',
              background: '#293450',
              image: undefined,
              dropShadow: {
                enabled: true,
                top: 3,
                left: 0,
                blur: 4,
                opacity: 0.24,
              },
            },
            track: {
              background: '#d6e0f0',
              // dropShadow: {
              //   enabled: true,
              //   top: 2,
              //   left: 0,
              //   blur: 4,
              //   opacity: 0.15,
              // },
            },
            dataLabels: {
              name: {
                offsetY: -10,
                color: '#fff',
                fontSize: '20px',
              },
              value: {
                color: '#fff',
                fontSize: '30px',
                show: true,
              },
              total: {
                show: true,
                color: '#fff',
                label: 'Completed Learner',
                formatter: function (w) {
                  if (w.globals.series[0] > 0) {
                    return w.globals.series[0] + '%';
                  } else {
                    return '00.00%';
                  }
                },
              },
            },
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'vertical',
            gradientToColors: ['#87D4F9', '#87D4F9'],
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: 'round',
        },
        colors: ['#0779e4', '#81b214'],
        labels: ['Completed Learner', 'Learning Progress'],
        legend: {
          show: false,
          labels: {
            useSeriesColors: true,
          },
          markers: {
            size: 0,
          },
          formatter: function (seriesName, opts) {
            return (
              seriesName + ':  ' + opts.w.globals.series[opts.seriesIndex] + '%'
            );
          },
          itemMargin: {
            vertical: 3,
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                show: false,
              },
            },
          },
        ],
      },

      overallSeries: [
        {
          name: 'Num of Learner',
          data: [],
        },
      ],
      overallChartOptions: {
        chart: {
          type: 'area',
          stacked: false,
          height: 350,

          zoom: {
            type: 'x',
            enabled: false,
            autoScaleYaxis: true,
          },
          toolbar: {
            tools: {
              download: false,
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
        },
        title: {
          text: '',
          align: 'left',
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0.5,
            stops: [0, 90, 100],
          },
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              if (Number.isInteger(val)) {
                return val;
              }
            },
          },
          title: {
            text: 'Num of Students',
          },
        },
        xaxis: {
          type: 'datetime',
          tickAmount: 30,
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy',
          },
          colors: ['#669966'],
        },
      },
    };
  },

  mounted() {
    this.initialize();
    this.getTeacher();
  },
  watch: {
    searchdata(keyword) {
      this.searchInfo(keyword);
    },
    searchdataStudent(keyword) {
      this.searchInfoStudent(keyword);
    },
    selectedSkills() {
      this.newLengthSkill = this.selectedSkills.length;
    },
    async searchSkill(value) {
      if (value.length > 0) {
        let result = await loadSkillList({ search: value, limit: 10 });
        this.skill = [];
        await result.data.forEach(async (skillItem) => {
          this.skill.push(skillItem);
        });
      }
    },
  },
  computed: {
    fileRules() {
      const rules = [];

      if (this.lectureId === undefined) {
        const rule = (v) =>
          !!v || this.$vuetify.lang.t('$vuetify.plsChooseFile');

        rules.push(rule);
      }

      return rules;
    },

    selectedTags() {
      return this.$vuetify.lang.t(
        '$vuetify.courseManagement.filterBar.selectedTags'
      );
    },

    sortType() {
      return [
        this.$vuetify.lang.t(
          '$vuetify.courseManagement.filterBar.highToLowTime'
        ),
        this.$vuetify.lang.t(
          '$vuetify.courseManagement.filterBar.lowToHighTime'
        ),
        this.$vuetify.lang.t(
          '$vuetify.courseManagement.filterBar.highToLowRating'
        ),
        this.$vuetify.lang.t(
          '$vuetify.courseManagement.filterBar.lowToHighRating'
        ),
      ];
    },

    headers() {
      return [
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.courseList.courseImage'
          ),
          align: 'start',
          sortable: false,
          value: 'image',
        },
        {
          text: this.$vuetify.lang.t('$vuetify.courseManagement.courseName'),
          value: 'title',
          sortable: false,
          align: 'start',
        },
        {
          text: this.$vuetify.lang.t('$vuetify.courseManagement.teacherName'),
          value: 'teacher',
          sortable: false,
          align: 'start',
        },
        {
          text: this.$vuetify.lang.t('$vuetify.courseManagement.creatorName'),
          value: 'owner_by_student',
          sortable: false,
          align: 'start',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.courseList.category'
          ),
          value: 'category',
          sortable: false,
          align: 'start',
        },
        // {
        //   text: this.$vuetify.lang.t(
        //     "$vuetify.courseManagement.courseList.prices"
        //   ),
        //   value: "price",
        //   sortable: false,
        //   align: "start"
        // },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.courseList.status'
          ),

          align: 'start',
          value: 'active',
          sortable: false,
        },

        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.courseList.action'
          ),
          align: 'center',
          sortable: false,
          value: 'edit',
        },
      ];
    },

    headersBin() {
      return [
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.courseList.courseImage'
          ),
          align: 'start',
          sortable: false,
          value: 'image',
        },
        {
          text: this.$vuetify.lang.t('$vuetify.courseManagement.courseName'),
          value: 'title',
          sortable: false,
          align: 'start',
        },
        {
          text: this.$vuetify.lang.t('$vuetify.courseManagement.teacherName'),
          value: 'teacher',
          sortable: false,
          align: 'start',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.courseList.category'
          ),
          value: 'category',
          sortable: false,
          align: 'start',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.courseList.action'
          ),
          align: 'center',
          sortable: false,
          value: 'edit',
        },
      ];
    },
  },
  methods: {
    async getTeacher() {
      let teachers = await getUserList({ isTeacher: 'y' });
      teachers = teachers.data.map((u) => {
        return {
          name: `${u.firstName} ${u.lastName}`,
          avatar: u.image,
          _id: u._id,
        };
      });
      this.teachers = teachers;
    },
    initialize() {
      this.params = {
        searchCourse: this.searchCourse,
        searchStudent: this.searchStudent,
        sort: 'created_at',
        sortby: -1,
        page: 1,
        limit: 10,
        active: null,
        category: [],
        admins: [],
        skill: [],
      };
      this.paramsBin = {
        searchCourse: this.searchCourse,
        searchStudent: this.searchStudent,
        sort: 'created_at',
        sortby: -1,
        page: 1,
        limit: 10,
        active: null,
        category: [],
        skill: [],
      };

      this.isTeacher = this.$store.state.isTeacher
        ? this.$store.state.isTeacher
        : 'n';
      this.reject_note = this.$store.state.note ? this.$store.state.note : '';

      if (!this.$store.state.permission.viewCourse) {
        // this.registerTutoralert = true;
      } else if (!this.$store.state.permission.viewCourse) {
        // this.$store.state.isTeacher == "r" || this.$store.state.isTeacher == "w"
        //   ? (this.registerTutoralert = true)
        //   :
        this.noPermission();
      } else if (this.$store.state.permission.viewCourse) {
        // if (
        //   this.$store.state.isTeacher == "r" ||
        //   this.$store.state.isTeacher == "w"
        // ) {
        //   this.registerTutoralert = true;
        // } else {
        this.getCourseList();
        this.getCategoryList();
        // this.getSkillList();
        this.getTagList();
        this.getStudentCourseList();
        this.getCourseListBin();
        this.getUserGroupList();
        // }
      } else {
        this.getCourseList();
        this.getCategoryList();
        // this.getSkillList();
        this.getTagList();
        this.getStudentCourseList();
        this.getCourseListBin();
        this.getUserGroupList();
      }
      // this.$store.state.isTeacher == "n"
      // ? (this.registerTutoralert = true)
      //: (this.registerTutoralert = false);

      this.loading = false;

      this.searchdata = '';
      this.sortData = this.$vuetify.lang.t(
        '$vuetify.courseManagement.filterBar.highToLowTime'
      );
      this.searchCourse = null;
      this.searchStudent = null;
      this.searchby = this.$vuetify.lang.t('$vuetify.courseName');
      this.skill = [];
      this.selectedSkill = [];
      this.selectedSkills = [];
      this.searchSkill = null;
      this.newLengthSkill = 0;
      this.oldLengthSkill = 0;
      this.selectedCategory = null;
      this.active = 'null';
      this.status_toggle = 0;
    },

    async changePage(page) {
      this.params.page = page;
      await this.getCourseList();
    },
    async changePageBin(page) {
      this.paramsBin.page = page;
      await this.getCourseListBin();
    },
    async changePageStudent(page) {
      this.page_student = page;
      await this.getStudentCourseList();
    },
    async changePageEditScore() {
      this.arrTempScore = [];
      this.arrQuestion.forEach((arrq) => {
        this.arrTempScore.push({
          score: arrq.studentScore,
        });
      });
      await this.getQuestionListExam();
    },
    noPermission() {
      this.alert = true;
    },
    gotoDetail() {
      if (this.$store.state.permission.insertCourse) {
        this.$router.push({
          path: '/course/detail',
        });
      } else {
        this.noPermission();
      }
    },
    onSort() {
      let index = this.sortType.indexOf(this.sortData);

      this.params.sortby = index % 2 == 0 ? -1 : 1;
      this.params.sort = index < 2 ? 'created_at' : 'countMylib';

      this.getCourseList();
    },

    selectAllToggle(props) {
      if (
        this.selectCourses.length !=
        this.courses.length - this.disabledCount
      ) {
        console.log('if');
        this.selectCourses = [];
        const self = this;
        props.items.forEach((item) => {
          // if (item.active == false) {
          self.selectCourses.push(item);
          // }
        });
      } else {
        console.log('else');
        this.selectCourses = [];
      }
    },

    selectAllToggleBin(props) {
      if (
        this.selectCoursesBin.length !=
        this.courses.length - this.disabledCount
      ) {
        console.log('if');
        this.selectCoursesBin = [];
        const self = this;
        props.items.forEach((item) => {
          if (item.active == false) {
            self.selectCoursesBin.push(item);
          }
        });
      } else {
        console.log('else');
        this.selectCoursesBin = [];
      }
    },

    cancelSelect() {
      // this.select();
      this.selectCourses = [];
      this.actionCourses = [];
    },
    cancelSelectBin() {
      // this.select();
      this.selectCoursesBin = [];
      this.actionCoursesBin = [];
    },
    confirmDelete(item) {
      this.actionCourses = item;

      console.log(this.actionCourses);
      this.dialogDelete = true;
    },
    canDeleteCourse(item) {
      if (
        item.admins &&
        item.owner_by_student._id._id !== this.$store.state._id
      ) {
        // เช็คว่าเป็น admin แต่ไม่ได้เป็น owner
        const isAdmin = item.admins.includes(this.$store.state._id);
        return !isAdmin;
      }
      return true;
    },
    confirmMultiDelete(item) {
      if (item != null) {
        this.actionCourses = item;
      }
      console.log(this.selectCourses);
      this.dialogMultiDelete = true;
    },
    confirmRecover(item) {
      this.actionCoursesBin = item;

      console.log(this.actionCoursesBin);
      this.dialogRecover = true;
    },
    confirmMultiRecover(item) {
      if (item != null) {
        this.actionCoursesBin = item;
      }
      console.log(this.selectCoursesBin);
      console.log(this.actionCoursesBin);
      this.dialogMultiRecover = true;
    },

    async deleteCourse() {
      let arrayid = [];
      this.loadingDelete = true;
      if (this.actionCourses.active == true) {
        this.updateActiveId = this.actionCourses.id;
        let status = await updateActive({
          id: this.updateActiveId,
          active: false,
        });
      }
      arrayid.push({ id: this.actionCourses.id });
      console.log(arrayid);
      let result = await moveCourseToBin({
        arrayid,
        istrash: true,
      });
      console.log(result);

      this.loadingDelete = false;
      this.dialogDelete = false;
      this.dialogMultiDeleteSuccess = true;

      this.actionCourses = [];
      this.page = 1;
      this.pageCount - 1;
      await this.initialize();
    },
    async deleteMultiCourse() {
      let arrayid = [];
      for (let i in this.selectCourses) {
        this.loadingDelete = true;
        if (this.selectCourses[i].active == true) {
          let status = await updateActive({
            id: this.selectCourses[i].id,
            active: false,
          });
        }
        // if (this.selectCourses[i].active == false) {
          arrayid.push({ id: this.selectCourses[i].id });
        // }
      }
      console.log(arrayid);
      let result = await moveCourseToBin({
        arrayid,
        istrash: true,
      });
      console.log(result);

      this.loadingDelete = false;
      this.dialogMultiDelete = false;
      this.dialogMultiDeleteSuccess = true;

      this.selectCourses = [];
      this.page = 1;
      this.pageCount - 1;
      await this.initialize();
    },

    async recoverCourse() {
      let arrayid = [];
      // for (let i in this.actionCoursesBin) {
      this.loadingRecover = true;
      if (this.actionCoursesBin.active == false) {
        arrayid.push({ id: this.actionCoursesBin.id });
      }
      // }

      console.log(arrayid);
      let result = await moveCourseToBin({
        arrayid,
        istrash: false,
      });
      let status = await updateActive({
        id: this.actionCoursesBin.id,
        active: true,
      });
      console.log(result);

      this.loadingRecover = false;
      this.dialogRecover = false;
      this.dialogMultiRecoverSuccess = true;

      this.actionCoursesBin = [];
      this.page = 1;
      this.pageCount - 1;
      await this.initialize();
    },

    async recoverMultiCourse() {
      let arrayid = [];
      if (this.actionCoursesBin) {
        // for (let i in this.actionCoursesBin) {
        this.loadingRecover = true;
        if (this.actionCoursesBin.active == false) {
          arrayid.push({ id: this.actionCoursesBin.id });
        }
        // }
      }
      if (this.selectCoursesBin) {
        console.log(this.selectCoursesBin);
        for (let i in this.selectCoursesBin) {
          this.loadingRecover = true;
          if (this.selectCoursesBin[i].active == false) {
            arrayid.push({ id: this.selectCoursesBin[i].id });
          }
        }
      }

      console.log(arrayid);
      let result = await moveCourseToBin({
        arrayid,
        istrash: false,
      });
      console.log(result);
      for(let courseId of arrayid){
        let status = await updateActive({
          id: courseId.id,
          active: true,
        });
      }

      this.loadingRecover = false;
      this.dialogMultiRecover = false;
      this.dialogMultiRecoverSuccess = true;

      this.selectCoursesBin = [];
      this.page = 1;
      this.pageCount - 1;
      await this.initialize();
    },

    closeDialogRecover() {
      this.dialogMultiRecoverSuccess = false;
      this.dialogRecycleBin = false;
    },

    async openRecycleBin() {
      this.dialogRecycleBin = true;
      await this.getCourseListBin();
    },

    async getCourseListBin() {
      let result = await getCourseListBin(this.paramsBin);
      this.coursesBin = [];
      // (this.pageCount = Math.ceil(result.data.length / this.limit)),
      this.pageCountBin = result.maxPage;
      result.data.forEach((course) => {
        this.coursesBin.push({
          id: course._id,
          image: course.image,
          title: course.title,
          teacher: course.owner_by_students,
          category: course.categories,
          price: course.prices,
          active: course.active,
        });
      });

      let requestArr = this.$store.state.requestData;
      await requestArr.forEach((request) => {
        this.coursesBin.forEach((course, index) => {
          if (request._id == course.id) {
            this.coursesBin[index] = {
              ...course,
              learnerRequest: request.totalLearner,
            };
          }
        });
      });
    },

    async closeDialogRecycleBin() {
      this.dialogRecycleBin = false;
      await this.getCourseList();
    },

    editItem(item) {
      if (this.$store.state.permission.updateCourse) {
        let index = this.courses.indexOf(item);
        let editCourse = this.courses[index];

        this.$router.push({
          path: '/course/detail',
          query: {
            id: editCourse.id,
            step: 1,
          },
        });
      } else {
        this.noPermission();
      }
    },
    async getQuestionListExam() {
      let data = {
        idexam: this.itemExam.examId,
        idstudent: this.itemExam.studentId,
        term: this.itemExam.num - 1,
        page: this.page_editScore,
        limit: 10,
      };
      let result = await getListQuestionExam(data);

      this.arrQuestion = [];
      result.data.forEach((quiz) => {
        this.arrQuestion.push({
          id: quiz.question._id,
          question: quiz.question.question,
          questionType: quiz.question.typeQuestion,
          choices: quiz.question.choices,
          correctAnswer: quiz.question.correct,
          correctText: quiz.question.correctText,
          questionMatch: quiz.question.questionMatch,
          correctMatch: quiz.question.correctMatch,
          // imageQuestion: quiz.question.imageQuestion,
          QuestionScore: quiz.question.score,

          studentAnswerText: quiz.answerStudent
            ? quiz.answerStudent.answerText
            : [''],
          studentAnswerMatch: quiz.answerStudent
            ? quiz.answerStudent.answerMatch
            : [''],
          studentAnswer: quiz.answerStudent ? quiz.answerStudent.answer : [''],
          studentIdState: quiz.question.state,
          studentScore: quiz.answerStudent ? quiz.answerStudent.score : 0,

          divider: true,
          boolean: false,
        });
      });
      this.pageCount_editScore = result.maxPage;
    },
    editScore(item) {
      this.itemExam = item;
      this.getQuestionListExam();
      this.dialogEditScoreExam = true;
    },
    editScoreExam(item) {
      this.bool = true;
      item.boolean = true;
      this.tempScore = item.studentScore;
      this.editScoreItem = item;
    },
    cancelEditScore(item) {
      item.boolean = false;
      item.studentScore = this.tempScore;
      this.bool = false;
    },
    async saveEditScore(item) {
      item.boolean = false;
      this.bool = false;

      this.editScoreItem = item;
      if (
        this.editScoreItem.studentScore == '' ||
        this.editScoreItem.studentScore == null
      ) {
        this.editScoreItem.studentScore = 0;
      }
      let data = {
        idstate: this.editScoreItem.studentIdState,
        score: this.editScoreItem.studentScore,
      };
      // for (var i = 0; i < this.pageCount_editScore; i++) {
      // for (var q = 0; q < this.arrQuestion.length; q++) {
      //   let result = await editScore({
      //     idstate: this.arrQuestion[q].studentIdState,
      //     score: this.arrQuestion[q].studentScore,
      //   });
      // }
      // }
      let result = await editScore(data);
      if (result) {
        this.getQuestionListExam();
      }
      this.dialogSuccess = true;
      // this.closedialogEditScoreExam();
    },
    deleteItem() {
      this.deleteDialog = false;
      const index = this.courses.indexOf(this.deleteItemID);

      this.courses.splice(index, 1);
    },
    openModal(item) {
      this.deleteItemID = this.courses.indexOf(item);
      this.deleteDialog = true;
    },

    searchInfo(keyword) {
      if (
        this.searchby ==
        this.$vuetify.lang.t('$vuetify.courseManagement.courseName')
      ) {
        this.params.searchStudent = null;
        this.params.searchCourse = keyword;
      }

      if (
        this.searchby ==
        this.$vuetify.lang.t('$vuetify.courseManagement.teacherName')
      ) {
        this.params.searchStudent = keyword;
        this.params.searchCourse = null;
      }

      this.getCourseList();
    },

    async getCourseList() {
      this.loading = true;

      let result = await getCourse(this.params);
      this.courses = [];
      // (this.pageCount = Math.ceil(result.data.length / this.limit)),
      this.pageCount = result.maxPage;
      result.data.forEach((course) => {
        this.courses.push({
          id: course._id,
          image: course.image,
          title: course.title,
          teacher: course.owner_by_students,
          category: course.categories,
          admins: course.admins,
          price: course.prices,
          active: course.active,
          owner_by_student: (course.owner_by_students || []).filter(
            (d) => d.initCreate
          )[0],
        });
      });

      let requestArr = this.$store.state.requestData;
      await requestArr.forEach((request) => {
        this.courses.forEach((course, index) => {
          if (request._id == course.id) {
            this.courses[index] = {
              ...course,
              learnerRequest: request.totalLearner,
            };
          }
        });
      });

      this.loading = false;
    },
    skillEnterKey(e) {
      this.autoselectMenu = false;
    },
    skillOtherKey() {
      this.autoselectMenu = true;
    },

    async applyFilter() {
      this.filterdialog = false;
      let skillId = [];
      console.log('apply filter');
      console.log(this.selectedSkills);
      // let tmpSelectedSkill = this.selectedSkills;
      for (let i = 0; i < this.selectedSkills.length; i++) {
        let foundIndex = this.skill.findIndex(
          (skil) => skil.title == this.selectedSkills[i]
        );
        console.log('foundIndex', foundIndex);
        if (foundIndex > -1) {
          this.selectedSkills[i] = {
            title: this.selectedSkills[i],
            _id: this.skill[foundIndex]._id,
          };
        }
      }
      this.selectedSkills = this.selectedSkills.filter((skill) => skill._id);
      this.autoselectMenu = false;
      for (let i = 0; i < this.selectedSkills.length; i++) {
        if (this.selectedSkills[i]._id) {
          skillId.push(this.selectedSkills[i]._id);
          this.searchSkill = null;
        }
      }
      let category = this.selectedCategory ? this.selectedCategory._id : '';

      this.params.skill = skillId;
      this.params.page = 1;
      this.params.category = category;
      this.params.active = this.active;
      await this.getCourseList();
    },

    async applyFilterUserGroup() {
      let itemUserGroupsId = [];
      this.params.groupnull = false;
      this.userGroupSearch.forEach((element) => {
        if (element._id != '') {
          itemUserGroupsId.push(element._id);
        } else {
          this.params.groupnull = true;
        }
      });
      this.params.usergroup = itemUserGroupsId;
      this.params.page = 1;
      await this.getCourseList();
    },

    async getCategoryList() {
      this.category = await loadCategory();
    },

    async getSkillList() {
      this.skill = await loadSkillList();
      // this.skill = await loadSkill();
    },
    async getTagList() {
      const tag = await loadTagList();
      this.tag = tag.data;
      // console.log("this.tag ::: ", this.tag);
    },
    //user
    async openUserModal(item) {
      let index = this.section_data.indexOf(item);
      this.roomID = this.section_data[index].id;
      this.userDialog = true;
      this.selectSectionDialog = false;
      // await this.getlistUser();
    },
    async CloseUserModal() {
      this.userDialog = false;
    },

    async opendialogExamReport(title) {
      this.dialogExamReport = true;
      this.examTitle = title;
    },

    closeDialogExamReport() {
      this.dialogExamReport = false;
      this.examTitle = '';
      this.fullScore = '';
      this.numOfQuestions = '';
      this.studentReportExams = [];
    },
    async closedialogEditScoreExam() {
      this.dialogEditScoreExam = false;
      this.arrQuestion = [];
      await this.getReportStudentExamScore(this.primaryExamId);
    },

    closeDialogFullReport() {
      this.dialogFullReport = false;

      // Clear Dialog Full Report Data
      this.imageCourse = '';
      this.title = '';
      this.courseId = '';
      this.instructorName = '';
      this.roomId = '';
      this.roomsCourse = [];
      this.section_data = [];
      this.selectedRoom = '';
      this.searchdataStudent = '';
      this.reportStudentList = [];
      this.status_student_toggle = 0;
    },

    closeDialogViewReport() {
      // Clear Dialog View Report Data
      this.dialogViewReport = false;

      this.fullName = '';
      this.userName = '';
      this.email = '';
      this.tel = '';
      this.birthdate = '';
      this.gender = '';

      this.historyList = [];
    },

    //section Modal
    setViewReport(item) {
      this.chooseRoom = true;
      this.objCourse = item;
      // this.courseId = item.id;
      if (this.chooseRoom == true) {
        this.openSectionModalReport(item);
      }
    },
    async openModalStatus(item) {
      let index = this.courses.indexOf(item);
      this.updateActiveId = this.courses[index].id;
      this.updateActive = this.courses[index].active;

      if (this.courses[index].active == true) {
        this.dialogStatus = true;
      } else {
        this.dialogStatusActive = true;
      }
    },
    async canPublicCourse() {
      let resultCourseDetail = await getCourseById({
        id: this.updateActiveId,
      });
      if (resultCourseDetail.sections.length > 0) {
        for (
          let indxSection = 0;
          indxSection < resultCourseDetail.sections.length;
          indxSection++
        ) {
          let lenghtLecture =
            resultCourseDetail.sections[indxSection].lectures.length;
          if (lenghtLecture > 0) {
            this.checkLenghtLectureEachSection = true;
          }
        }
      } else {
        this.checkLenghtLectureEachSection = false;
      }

      let resultRoom = await getRoom({
        idcourse: this.updateActiveId,
      });
      //   let resultBundle = await getListBundles({
      //     idcourse: this.updateActiveId,
      //   });
      let resultLive = await getLive({
        idcourses: this.updateActiveId,
      });

      if (
        resultRoom.length <= 0 ||
        resultRoom.filter((room) => room.active == true).length <= 0
      ) {
        this.messageCantPublic =
          'คอร์สเรียนต้องมีกลุ่มห้องเรียนที่เปิดอย่างน้อย 1 กลุ่ม';
        return false;
      } else if (
        resultCourseDetail.sections.length > 0 &&
        this.checkLenghtLectureEachSection === false &&
        !resultLive.data
      ) {
        this.messageCantPublic =
          'บทเรียนต้องมีเนื้อหาอย่างน้อย 1 บท หรือมีการถ่ายทอดสดอย่างน้อย 1 ครั้ง';
        return false;
      } else if (
        resultCourseDetail.sections.length > 0 &&
        this.checkLenghtLectureEachSection === false
      ) {
        this.messageCantPublic = 'บทเรียนต้องมีเนื้อหาอย่างน้อย 1 บท';
        return false;
      } else if (resultCourseDetail.sections.length <= 0 && !resultLive.data) {
        this.messageCantPublic =
          'บทเรียนต้องมีเนื้อหาอย่างน้อย 1 บท หรือมีการถ่ายทอดสดอย่างน้อย 1 ครั้ง';
        return false;
      } else {
        return true;
      }
    },
    async userUpdateActive() {
      let active = !this.updateActive;
      if (active) {
        let canPublicCourseStatus = await this.canPublicCourse();
        if (!canPublicCourseStatus) {
          this.dialogCantPublic = true;
          this.closeDialogActive();
          return;
        }
      }
      let status = await updateActive({
        id: this.updateActiveId,
        active: active,
      });
      this.checkLenghtLectureEachSection = false;
      this.statusExamOfOneLenghtLecture = false;
      this.dialogSuccess = true;
      this.closeDialogActive();
      return status;
    },
    closeDialogActive() {
      this.dialogStatus = false;
      this.dialogStatusActive = false;
      this.getCourseList();
    },
    setChooseSection(item) {
      this.chooseRoom = false;
      this.chooseSection = true;
      if (this.chooseSection == true) {
        this.openSectionModal(item);
      }
    },
    async openSectionModal(item) {
      this.section_data = [];
      if (this.$store.state.permission.updateCourse) {
        let index = this.courses.indexOf(item);
        this.manageUserCourseID = this.courses[index].id;
        let data = {
          idcourse: this.courses[index].id,
        };
        this.selectSectionDialog = true;

        let result = await getRoom(data);
        // (this.pageCount_section = Math.ceil(result.length / this.limit)),
        result.forEach((room) => {
          this.section_data.push({
            id: room._id,
            teacher: room.teacher,
            title: room.title,
            countStudent: room.countStudent,
          });
        });

        // this.section_data.map(section => {
        //   this.roomsCourse.push(section.title);
        // });
        // this.openDialogGetReport(this.section_data);
      } else {
        this.noPermission();
      }
    },
    async openSectionModalReport(item) {
      this.section_data = [];
      if (this.$store.state.permission.updateCourse) {
        let index = this.courses.indexOf(item);
        this.manageUserCourseID = this.courses[index].id;
        let data = {
          idcourse: this.courses[index].id,
        };
        // this.selectSectionDialog = true;

        let result = await getRoom(data);
        // (this.pageCount_section = Math.ceil(result.length / this.limit)),
        result.forEach((room) => {
          this.section_data.push({
            id: room._id,
            teacher: room.teacher,
            title: room.title,
            countStudent: room.countStudent,
          });
        });

        this.section_data.map((section) => {
          this.roomsCourse.push(section.title);
        });
        this.openDialogGetReport(this.section_data);
      } else {
        this.noPermission();
      }
    },
    closeSectionModal() {
      this.selectedSection = [];
      this.selectSectionDialog = false;
    },
    openConfirmDialog() {
      this.registerTutoralert = false;
      this.confirmDialog = true;
    },
    async closeConfirmDialog() {
      this.confirmDialog = false;
      //this.registerTutoralert = true;
    },

    //section report
    refreshFilter() {
      this.initialize();
    },
    refreshStudent() {
      // this.initialize();
      this.searchdataStudent = '';
      this.selectedRoom = '';
      this.status_student_toggle = 0;
      this.openDialogGetReport(this.section_data);
    },
    searchInfoCourse() {
      this.params.search = this.searchdata;
      this.getReportCourseList();
    },

    searchInfoStudent(keyword) {
      this.params.search = keyword;
      this.getStudentCourseList();
    },

    applyStudentFilter() {
      this.getStudentCourseList();
    },

    async preview() {
      if (this.imageFile != null) {
        this.imgURL = await this.uploadImg(this.imageFile);
        this.imgPreview = this.imgURL;
        this.imageReady = true;
      } else {
        this.imageReady = false;
      }
    },

    async uploadImg(image) {
      let status = await uploadImage('user', image);
      return status;
    },

    async viewProgressReport(item) {
      this.dialogViewReport = true;
      this.image = item.image;
      this.fullName = item.fullName;
      this.userName = item.userName;
      this.email = item.email;
      this.tel = item.tel == '' || item.tel == null ? '-' : item.tel;
      this.birthdate =
        item.birthdate == '' || item.birthdate == null
          ? '-'
          : new Date(item.birthdate).toLocaleDateString();
      this.gender =
        item.gender == '' || item.gender == null ? '-' : item.gender;

      this.courseId = this.objCourse.id;
      this.studentId = item.id;
      this.getReportHistory();
    },

    async openDialogGetReport(item) {
      this.dialogFullReport = true;
      this.imageCourse = this.objCourse.image;
      this.title = this.objCourse.title;
      this.courseId = this.objCourse.id;
      this.selectedRoom = this.roomsCourse[0];
      // this.roomTitle = item[0].title;
      this.instructorName = item[0].teacher.displayName;
      this.roomId = item[0].id;
      this.getOverviewReport();
      this.getStudentCourseList();

      this.onlineUserRef = database
        .ref('/onlineUser')
        .child(`/course_${this.courseId}`);
      this.onlineUserRef.on('value', (snapshot) => {
        this.onlineUser = snapshot.val()
          ? snapshot.val().length > 1
            ? snapshot.val().length
            : 1
          : 0;
      });
    },

    async onChangeRoom() {
      let index = this.roomsCourse.indexOf(this.selectedRoom);
      // this.roomTitle = this.section_data[index].title;
      this.instructorName = this.section_data[index].teacher.displayName;
      this.roomId = this.section_data[index].id;
      this.getOverviewReport();
      this.getStudentCourseList();
    },

    async getReportCourseList() {
      this.loading = true;
      let result = await getReportCourse(this.params);
      this.reportCourseList = [];
      result.forEach((course) => {
        this.reportCourseList.push({
          id: course._id,
          imageCourse: course.image,
          title: course.title,
          category: course.categories,
        });
      });
      this.imageReady = true;
      this.loading = false;
    },

    async getReportStudentExamScore(examId) {
      this.studentReportExams = [];
      this.primaryExamId = examId;
      let result = await getReportExamScore({
        idexam: examId,
        idstudent: this.studentId,
      });

      this.fullScore = result.maxScore;
      this.numOfQuestions = result.countQuestion;
      let numExam = result.data.length + 1;
      result.data.forEach((reportExam) => {
        numExam--;
        this.studentReportExams.push({
          examId: this.primaryExamId,
          studentId: this.studentId,
          num: numExam,
          examDate:
            new Date(reportExam.created_at).toDateString() +
            ' ' +
            new Date(reportExam.created_at).toLocaleTimeString(),
          score: reportExam.score,
          correct: reportExam.correct,
          wrong: reportExam.wrong,
          noAnswer: reportExam.noAnswer,
        });
      });
    },

    async getStudentCourseList() {
      this.loading = true;
      let resultStudent = await getReportStudentInCourse({
        idcourse: this.courseId,
        idroom: this.roomId,
        search: this.params.search,
        page: this.page_student,
        limit: this.limit_student,
      });

      let result = [];
      this.countStartedStudents = resultStudent.data.filter(
        (filter) => filter.percent > 0
      );
      this.countNotStartedStudents = resultStudent.data.filter(
        (filter) => filter.percent == 0
      );

      if (this.status_student_toggle == 1) {
        result = resultStudent.data.filter((filter) => filter.percent > 0);
      } else if (this.status_student_toggle == 2) {
        result = resultStudent.data.filter((filter) => filter.percent == 0);
      } else {
        result = resultStudent.data;
      }

      this.reportStudentList = [];
      result.forEach((student) => {
        this.reportStudentList.push({
          id: student._id,
          image: student.image,
          fullName: student.firstName + ' ' + student.lastName,
          email: student.email,
          userName: student.username,
          tel: student.tel,
          birthdate: student.birthdate,
          gender: student.gender,
          room: student.room.title,
          percent: student.percent,
        });
      });
      this.imageReady = true;
      this.loading = false;
      this.pageCount_student = resultStudent.maxPage;
    },
    async getOverviewReport() {
      let result = await getOverviewReportCourse({
        idcourse: this.courseId,
        idroom: this.roomId,
      });
      this.completedUser = result.countPercent100;
      this.notCompletedUser = result.allUser - result.countPercent100;
      this.totalUser = result.allUser;
      this.userToday = result.onlineToday.countOnline;
      this.totalPercent = result.allUser * 100;
      this.sumPercentProgress = result.sumPercent;
      this.sumPercentProgress = (result.sumPercent * 100) / this.totalPercent;
      this.differencePercent = 100 - this.sumPercentProgress;
      this.series = [this.sumPercentProgress, this.differencePercent];
      this.seriesLearningProgress = [this.completedUser, this.notCompletedUser];
      this.seriesAngleCircle = [
        ((this.completedUser * 100) / this.totalUser).toFixed(2),
        this.sumPercentProgress.toFixed(2),
      ];
      let arrayGraph = result.arrayGraph;
      this.overallSeries[0].data = [];
      arrayGraph.map((graph) => {
        this.overallSeries[0].data.push([graph.date, graph.countOnline]);
      });
      let newSeries = this.overallSeries[0].data;
      this.overallSeries = [
        {
          data: newSeries,
        },
      ];
    },

    async getReportHistory() {
      let result = await getReportStudentHistory({
        idcourse: this.courseId,
        idstudent: this.studentId,
      });
      this.historyList = result;
      this.historyExamList = [];
      this.dataForExcel = [];
      this.knowledge = this.historyList.avgPercentAll;
      this.hisAvg = this.historyExamList.hisAvg;
      result.lectureExam.forEach((history) => {
        this.historyExamList.push({
          hisExamTitle: history.lecture.exams[0].title,
          hisExamType: history.type,
          hisAvg: history.avgScore,
          hisScore: history.getAllScore.map((term) => term.score),
          hisWrong: history.getAllScore.map((term) => term.wrong),
          hisCorrect: history.getAllScore.map((term) => term.correct),
          series: [
            {
              name: 'คะแนนของคุณ',
              data: history.getAllScore.map((term) => term.score),
            },
          ],
          chartOptions: {
            // chart: {
            //   type: "bar"
            // },
            // plotOptions: {
            //   bar: {
            //     horizontal: false,
            //     columnWidth: "50%"
            //   }
            // },
            // dataLabels: {
            //   enabled: false
            // },
            // stroke: {
            //   show: true,
            //   width: 2,
            //   colors: ["transparent"]
            // },
            // grid: {
            //   row: {
            //     colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            //     opacity: 0.5
            //   }
            // },
            // xaxis: {
            //   categories: history.getAllScore.map((term, index) => index + 1)
            // },
            // // yaxis: {
            // //   subtitle: {
            // //     text: "คะแนน"
            // //   }
            // // },
            // fill: {
            //   opacity: 1
            // },
            // tooltip: {
            //   y: {
            //     formatter: function(val) {
            //       return val + " คะแนน";
            //     }
            //   }
            // }
            chart: {
              height: 350,
              type: 'line',
              zoom: {
                enabled: false,
              },
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: 'straight',
            },
            grid: {
              row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5,
              },
            },
          },
        });
      });
      this.historyExamList.sort(function (a, b) {
        return b.hisScore.length - a.hisScore.length;
      });
      this.historyExamList.forEach((exam) => {
        let data = {
          รายการข้อสอบ: exam.hisExamTitle,
        };
        exam.hisScore.forEach((score, index) => {
          data[`ครั้งที่ ${index + 1}`] = score;
        });
        data[`คะแนนเฉลี่ย`] = exam.hisAvg;

        this.dataForExcel.push(data);
      });
    },

    dowloadExcel() {
      this.excelList = [];
      this.historyExamList.forEach((data) => {
        this.excelList.push({
          dataForExcel: [
            {
              รายการสอบ: data.hisExamTitle,
            },
          ],
        });
      });
      // fileExcelName: "รายงานสรุปผลการสอบ.xls",
      //   dataForExcel: [
      //   { รายการสอบ: "Hello", colB: "World" },
      //   {
      //     colA: "Multi-line",
      //     colB:
      //       "This is a long paragraph\nwith multiple lines\nthat should show in a single cell."
      //   },
      //   { colA: "Another", colB: "Regular cell" }
      // ],
    },

    async getUserEdit(item) {
      let result = await getUserEditByID({
        idstudent: item.id,
      });
      this.editUserId = item.id;
      this.imgPreview = result.image;
      this.imageReady = true;
      this.firstName = result.firstName;
      this.lastName = result.lastName;
      this.email = result.email;
      this.username = result.username;
    },

    async userEdit(item) {
      this.dialogFormUser = true;
      this.imageReady = true;

      if (item) {
        this.isEdit = true;
        this.getUserEdit(item);
      } else {
        this.isEdit = false;
        this.$refs.form.resetValidation();
        this.firstName = '';
        this.lastName = '';
        this.email = '';
        this.username = '';
      }
    },
    //filter
    changeActive(active) {
      this.active = active;
      this.changePage(1);
      this.applyFilter();
    },

    //check student anser correct
    getstudentCorrectAnser(idStudentAnsser, idCorrectAnser) {
      let id_correct = '';
      idStudentAnsser == idCorrectAnser
        ? (id_correct = idStudentAnsser)
        : (id_correct = '');
      return id_correct;
    },
    getCorrectAnser(idAnswer, correctAnser) {
      let correct = correctAnser.filter((key) => key == idAnswer);
      return correct;
    },
    chekCorrectAnser(idChioce, correctAnser) {
      let correct = correctAnser.filter((key) => key == idChioce);

      if (correct.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    showAnswer(corrects, choices) {
      let answer = choices.filter(function (choice) {
        if (corrects.correct == choice._id) {
          return choice;
        }
      });
      this.correct_matchsome = answer[0];
      this.correct_dialog = true;
    },
    viewReport(item) {
      console.log(item);
      let index = this.courses.indexOf(item);
      console.log(index);
      let course = this.courses[index];

      this.$router.push({
        path: '/course/report',
        query: {
          id: course.id,
        },
      });
    },
    async getUserGroupList() {
      let paramsG = {
        search: null,
        sort: 'created_at',
        sortby: -1,
        usergroup: null,
        page: 1,
        limit: 100,
        active: 'null',
      };
      let result = await getUserGroup(this.paramsG);
      this.groupUsers = [];
      this.arrayGroup = [];
      this.arrayGroup.push({
        title: 'ไม่มีกลุ่ม',
        _id: '',
      });
      await result.forEach(async (group) => {
        group.child_User_Group.length === 0
          ? await this.arrayGroup.push({
              title: group.title,
              _id: group._id,
            })
          : null;
        group.child_User_Group.forEach(async (child) => {
          child.child_User_Group.length === 0
            ? await this.arrayGroup.push({
                title: group.title + ' -> ' + child.title,
                _id: child._id,
              })
            : null;
          child.child_User_Group.forEach(async (lastChild) => {
            await this.arrayGroup.push({
              title:
                group.title + ' -> ' + child.title + ' -> ' + lastChild.title,
              _id: lastChild._id,
            });
          });
        });
      });
      this.groupUsers = result;
      await this.arrayGroup.filter((group) => group.active === true);
    },
  },
  created() {
    const self = this;
    this.courses.map((item) => {
      if (item.active) self.disabledCount += 1;
    });
  },
};
</script>

<style lang="scss" scoped>
.correct {
  color: #4caf50;
  border: 1px solid #4caf50 !important;

  .check {
    position: absolute;
    left: 5px;
    top: 13px;

    i {
      color: #4caf50;
    }
  }

  p {
    color: #4caf50;
  }
}

.incorrect {
  color: #f44336;
  border: 1px solid #f44336 !important;

  .check {
    position: absolute;
    left: 5px;
    top: 13px;

    i {
      color: #f44336;
    }
  }

  p {
    color: #f44336;
  }
}

.page-card {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.selectCourse {
  height: auto;
}

.fixed-heght {
  height: 30px;
}

.rounded-card {
  border-radius: 8px;
}

/* .v-text-field--filled > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 40px;
} */
.v-input__append-inner {
  margin-top: 9px !important;
}

.md-fixed-max-width {
  max-width: 200px;
}

.add-course .full-width {
  width: 100%;
}

.img-padding {
  display: flex;
  align-items: center;
  justify-content: center;
}

.apexcharts-toolbar {
  visibility: hidden;
  display: none;
}

.d-flex {
  display: flex;
}

@media only screen and (max-width: 768px) {
  .hiddex-xs {
    display: none;
  }

  .xs-full-max-width {
    max-width: 100%;
  }

  .md-fixed-width {
    width: 150px;
  }

  .xs-fixed-width {
    width: 100px;
  }

  .table-header {
    height: auto !important;
  }

  .table-header .v-toolbar__content {
    height: auto !important;
    flex-flow: column !important;
    padding: 0 !important;
  }

  .xs-full-width {
    width: 50%;
  }
}

.border-bottom {
  border-bottom: 1px solid #cfd8dc;
}

.border-bottom:last-child {
  border-bottom: none;
}

.full-width {
  width: 100%;
}

.filter-header {
  display: flex;
  justify-content: space-between;
}

.md-border {
  border: 1px solid #bdbdbd;
}

.text-caption {
  color: #9b9b9b;
  text-transform: uppercase;
}

.btn-reload {
  background: #ffffff !important;
  border: 1px solid #d9d9d9;
  color: rgb(77, 77, 77);
  box-shadow: none !important;
}

.hidden-md {
  display: none;
}

.main {
  background-color: rgb(241, 243, 245);
}

.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}

.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}

.text-field-border {
  border: 1px solid;
  // border-radius: 8px;
  border-color: rgba(65, 65, 65, 0.3);
  background-color: white;
  height: 40px;
  color: rgb(77, 77, 77);
}

.title-text {
  color: rgb(140, 140, 140);
}

.text-primary {
  color: rgb(66, 154, 216) !important;
}

.have-border {
  border: thin solid #e4e4ee;
  border-radius: 4px;
}

.stat-num {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.stat-num-top {
  background-image: linear-gradient(rgba(#0779e4, 1), rgba(#0779e4, 0.7));
  color: white;
}

.stat-num-total {
  background-image: linear-gradient(rgba(#9f4355, 1), rgba(#9f4355, 0.7));
  color: white;
}

.stat-num-today {
  background-image: linear-gradient(rgba(#482f4d, 1), rgba(#482f4d, 0.7));
  color: white;
}

.stat-num-online {
  background-image: linear-gradient(rgba(#699ab2, 1), rgba(#699ab2, 0.7));
  color: white;
}

.stat-num-not-completed {
  background-image: linear-gradient(rgba(#ec0101, 1), rgba(#ec0101, 0.5));
  color: white;
}

.stat-num:hover {
  /* box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.19); */
  /* background-color: rgba(#0779e4, 0.4); */
  transform: scale(1.05, 1.05);
}

.graph-card {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 5px;
  background-color: white;
  transition: transform 0.3s ease-in-out;
}

.graph-card:hover {
  /* box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.19); */
  transform: scale(1.02, 1.02);
}

.v-application p {
  margin: 0 !important;
}

.number-border {
  /* padding: 5px; */
  width: 30px;
  height: 30px;
  position: relative;
}

.have-number-border {
  border: 1px solid #bdbdbd;
  border-radius: 20px;
  background: #bdbdbd87;
}

.number {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

p img {
  width: 100% !important;
}

.custom-icon {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
  margin-top: 0;
}

.custom-number-panel {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
}
</style>
<style>
.v-data-table.custom-table td {
  height: 0;
  padding: 0;
}

.v-data-table.custom-table td .backgroud-info {
  height: 48px;
  padding: 13px 0;
  border-bottom: 3px solid #2196f3;
}

.v-data-table.custom-table td .backgroud-success {
  height: 48px;
  padding: 13px 0;
  border-bottom: 3px solid #4caf50;
}

.v-data-table.custom-table td .backgroud-error {
  height: 48px;
  padding: 13px 0;

  border-bottom: 3px solid #f44336;
}

.v-data-table.custom-table td .backgroud-warning {
  height: 48px;
  padding: 13px 0;
  border-bottom: 3px solid #ffc107;
}

.v-data-table.custom-table thead tr th:nth-child(9) {
  border-bottom: 3px solid #ffc107 !important;
}

.v-data-table.custom-table thead tr th:nth-child(8) {
  border-bottom: 3px solid #f44336 !important;
}

.v-data-table.custom-table thead tr th:nth-child(7) {
  border-bottom: 3px solid #4caf50 !important;
}

.v-data-table.custom-table thead tr th:nth-child(6) {
  /*background: #B3E5FC !important;*/
  border-bottom: 3px solid #2196f3 !important;
}

.custom-question p {
  margin-bottom: 5px !important;
}

p > img {
  width: 100% !important;
}
.bg-sheet {
  background: #fafafa !important;
}
.custom-toolbar {
  background: #f2f3f5 !important;
}
</style>
